import { defineComponent as O, useCssVars as ln, computed as H, shallowRef as cn, watch as Pe, defineAsyncComponent as un, openBlock as D, createElementBlock as x, createBlock as W, resolveDynamicComponent as Fe, normalizeClass as B, withCtx as re, unref as he, createCommentVNode as R, createTextVNode as et, toDisplayString as U, createElementVNode as F, normalizeStyle as Oe, createVNode as Me, withDirectives as tt, mergeProps as ve, vModelRadio as dn, ref as oe, pushScopeId as kt, popScopeId as Mt, renderSlot as le, vModelText as fn, onMounted as pn, onUnmounted as mn, withKeys as Ct, Fragment as gn, Transition as hn } from "vue";
const vn = "#5785ed", yn = "#e3ebfc", bn = "#fbbd1c", wn = "#fff5db", Dn = "#67d2c0", kn = "#e4f7f4", Mn = "#f0649f", Cn = "#fce5ef", Tn = "#6731f2", Sn = "#e7defc", _n = "#5785ed", En = "#e3f5fa", xn = "#74da3e", In = "#e8f8df", Bn = "#9d39f1", An = "#eedffc", Hn = "#f15730", Pn = "#fce3dd", Ln = "#f78f30", Fn = "#fdecdd", Pr = {
  blueTint: vn,
  blueSoftTint: yn,
  yellowTint: bn,
  yellowSoftTint: wn,
  tealTint: Dn,
  tealSoftTint: kn,
  pinkTint: Mn,
  pinkSoftTint: Cn,
  purpleTint: Tn,
  purpleSoftTint: Sn,
  lightBlueTint: _n,
  lightBlueSoftTint: En,
  greenTint: xn,
  greenSoftTint: In,
  magentaTint: Bn,
  magentaSoftTint: An,
  redTint: Hn,
  redSoftTint: Pn,
  orangeTint: Ln,
  orangeSoftTint: Fn
}, On = "#ffffff", Nn = "#eceff1", Wn = "#fcfcfd", Rn = "#f1f6f9", Yn = "#e8f7fd", $n = "#e8f7fd", zn = "#c7d7ea", jn = "#f0f3f6", Vn = "#e5eaed", qn = "#000000", Un = "#52627a", Kn = "#ffffff", Jn = "#07835e", Gn = "#d02d10", Zn = "#1a5fb8", Qn = "#000000", Xn = "#5e768d", ea = "#ffffff", ta = "#8ca1b6", na = "#11ab7d", aa = "#ee4223", ia = "#fbbd1c", oa = "#1799e1", ra = "#ffffff", sa = "#048fdc", la = "#0488d1", ca = "#e8f7fd", ua = "#1050a4", da = "#def4fc", fa = "#caecfb", pa = "#ffffff", ma = "#1a5fb8", ga = "#f8fbfc", ha = "#f1f6f9", va = "#1a5fb8", ya = "#f1f6f9", ba = "#eaf1f6", wa = "#caecfb", Da = "#00386b", ka = "#bde7fa", Ma = "#aee2f9", Ca = "#b42a13", Ta = "#fce1dc", Sa = "#fbc9c3", _a = "#f9b9b2", Ea = "#0a5c44", xa = "#d6f1e3", Ia = "#abe9d0", Ba = "#8be3c2", Aa = "#000000", Ha = "#fff5db", Pa = "#ffe5aa", La = "#ffdd8f", $ = {
  primaryBackground: On,
  secondaryBackground: Nn,
  primarySurface: Wn,
  secondarySurface: Rn,
  tertiarySurface: Yn,
  highlightSurface: $n,
  primaryBorder: zn,
  secondaryBorder: jn,
  tertiaryBorder: Vn,
  primaryText: qn,
  secondaryText: Un,
  tertiaryText: Kn,
  positiveText: Jn,
  negativeText: Gn,
  primaryForeground: Zn,
  secondaryForeground: Qn,
  tertiaryForeground: Xn,
  quaternaryForeground: ea,
  inactiveForeground: ta,
  positiveForeground: na,
  negativeForeground: aa,
  warningForeground: ia,
  primaryButton: oa,
  primaryButtonLabel: ra,
  primaryButtonHover: sa,
  primaryButtonPressed: la,
  secondaryButton: ca,
  secondaryButtonLabel: ua,
  secondaryButtonHover: da,
  secondaryButtonPressed: fa,
  tertiaryButton: pa,
  tertiaryButtonLabel: ma,
  tertiaryButtonHover: ga,
  tertiaryButtonPressed: ha,
  ghostButtonLabel: va,
  ghostButtonHover: ya,
  ghostButtonPressed: ba,
  smallButton: wa,
  smallButtonLabel: Da,
  smallButtonHover: ka,
  smallButtonPressed: Ma,
  negativeAlertLabel: Ca,
  negativeAlertBackground: Ta,
  negativeAlertBackgroundHover: Sa,
  negativeAlertBackgroundPressed: _a,
  positiveAlertLabel: Ea,
  positiveAlertBackground: xa,
  positiveAlertBackgroundHover: Ia,
  positiveAlertBackgroundPressed: Ba,
  warningAlertLabel: Aa,
  warningAlertBackground: Ha,
  warningAlertBackgroundHover: Pa,
  warningAlertBackgroundPressed: La
}, Fa = "linear-gradient(168deg, #b3db11 0%, #1a9432 100%)", Oa = "linear-gradient(168deg, #f69d62 0%, #e23043 100%)", Lr = {
  primaryGradient: Fa,
  charityGradient: Oa
}, Na = "700", Wa = "700", Ra = "700", Ya = "500", $a = "300", za = "700", ja = "500", Va = "300", qa = "700", Ua = "500", Ka = "300", Ja = "700", Ga = "500", Za = "700", Qa = "500", Xa = "300", ei = "700", ti = "500", ni = "300", ai = "700", ii = "500", oi = "300", ri = "700", si = "500", li = "300", ci = "700", ui = "500", Fr = {
  fontWeightDisplayTitle: Na,
  fontWeightDisplayText: Wa,
  fontWeightPrimaryTitleBold: Ra,
  fontWeightPrimaryTitleMedium: Ya,
  fontWeightPrimaryTitleRegular: $a,
  fontWeightSecondaryTitleBold: za,
  fontWeightSecondaryTitleMedium: ja,
  fontWeightSecondaryTitleRegular: Va,
  fontWeightTertiaryTitleBold: qa,
  fontWeightTertiaryTitleMedium: Ua,
  fontWeightTertiaryTitleRegular: Ka,
  fontWeightHeadlineBold: Ja,
  fontWeightHeadlineMedium: Ga,
  fontWeightPrimaryTextBold: Za,
  fontWeightPrimaryTextMedium: Qa,
  fontWeightPrimaryTextRegular: Xa,
  fontWeightSecondaryTextBold: ei,
  fontWeightSecondaryTextMedium: ti,
  fontWeightSecondaryTextRegular: ni,
  fontWeightCaptionBold: ai,
  fontWeightCaptionMedium: ii,
  fontWeightCaptionRegular: oi,
  fontWeightSmallCaptionBold: ri,
  fontWeightSmallCaptionMedium: si,
  fontWeightSmallCaptionRegular: li,
  fontWeightButtonLabel: ci,
  fontWeightButtonLabelSmall: ui
}, di = "4rem", fi = "3rem", pi = "3rem", mi = "2.5rem", gi = "2.125rem", hi = "1.875rem", vi = "1.75rem", yi = "1.5rem", bi = "1.5rem", wi = "1.375rem", Di = "1.25rem", ki = "1.25rem", Mi = "1.125rem", Ci = "1.125rem", Ti = "1rem", Si = "1rem", _i = "0.875rem", Ei = "0.875rem", xi = "0.75rem", Ii = "0.75rem", Bi = "1.125rem", Ai = "1.125rem", Hi = "1rem", Pi = "1rem", Or = {
  fontSizeDisplayTitleDesktop: di,
  fontSizeDisplayTitleMobile: fi,
  fontSizeDisplayTextDesktop: pi,
  fontSizeDisplayTextMobile: mi,
  fontSizePrimaryTitleDesktop: gi,
  fontSizePrimaryTitleMobile: hi,
  fontSizeSecondaryTitleDesktop: vi,
  fontSizeSecondaryTitleMobile: yi,
  fontSizeTertiaryTitleDesktop: bi,
  fontSizeTertiaryTitleMobile: wi,
  fontSizeHeadlineDesktop: Di,
  fontSizeHeadlineMobile: ki,
  fontSizePrimaryTextDesktop: Mi,
  fontSizePrimaryTextMobile: Ci,
  fontSizeSecondaryTextDesktop: Ti,
  fontSizeSecondaryTextMobile: Si,
  fontSizeCaptionDesktop: _i,
  fontSizeCaptionMobile: Ei,
  fontSizeSmallCaptionDesktop: xi,
  fontSizeSmallCaptionMobile: Ii,
  fontSizeButtonLabelDesktop: Bi,
  fontSizeButtonLabelMobile: Ai,
  fontSizeButtonLabelSmallDesktop: Hi,
  fontSizeButtonLabelSmallMobile: Pi
}, Li = "max(28rem, 448px)", Fi = "max(48rem, 768px)", Oi = "max(64rem, 1024px)", Ni = "max(88rem, 1408px)", Nr = {
  tabletSmall: Li,
  tabletLarge: Fi,
  desktopSmall: Oi,
  desktopLarge: Ni
}, Wi = "1.1", Ri = "1.1", Yi = "1.2", $i = "1.2", zi = "1.2", ji = "1.2", Vi = "1.2", qi = "1.2", Ui = "1.2", Ki = "1.2", Ji = "1.2", Gi = "1.2", Zi = "1.2", Qi = "1.4", Xi = "1.4", eo = "1.4", to = "1.4", no = "1.4", ao = "1.4", io = "1.4", oo = "1.4", ro = "1.4", so = "1.4", lo = "1.4", co = "1.4", uo = "1.375", fo = "1.125", Wr = {
  lineHeightDisplayTitle: Wi,
  lineHeightDisplayText: Ri,
  lineHeightPrimaryTitleBold: Yi,
  lineHeightPrimaryTitleMedium: $i,
  lineHeightPrimaryTitleRegular: zi,
  lineHeightSecondaryTitleBold: ji,
  lineHeightSecondaryTitleMedium: Vi,
  lineHeightSecondaryTitleRegular: qi,
  lineHeightTertiaryTitleBold: Ui,
  lineHeightTertiaryTitleMedium: Ki,
  lineHeightTertiaryTitleRegular: Ji,
  lineHeightHeadlineBold: Gi,
  lineHeightHeadlineMedium: Zi,
  lineHeightPrimaryTextBold: Qi,
  lineHeightPrimaryTextMedium: Xi,
  lineHeightPrimaryTextRegular: eo,
  lineHeightSecondaryTextBold: to,
  lineHeightSecondaryTextMedium: no,
  lineHeightSecondaryTextRegular: ao,
  lineHeightCaptionBold: io,
  lineHeightCaptionMedium: oo,
  lineHeightCaptionRegular: ro,
  lineHeightSmallCaptionBold: so,
  lineHeightSmallCaptionMedium: lo,
  lineHeightSmallCaptionRegular: co,
  lineHeightButtonLabel: uo,
  lineHeightButtonLabelSmall: fo
}, Rr = ["a", "button"], Yr = ["primary", "secondary", "tertiary", "ghost"], $r = ["fill", "hug", "icon-only"], zr = ["primary", "secondary", "tertiary"], jr = ["a", "button"], Vr = [
  "default",
  "tertiary",
  "ghost",
  "negative",
  "positive"
], qr = [
  "display-title",
  "display-text",
  "primary-title-bold",
  "primary-title-medium",
  "primary-title-regular",
  "secondary-title-bold",
  "secondary-title-medium",
  "secondary-title-regular",
  "tertiary-title-bold",
  "tertiary-title-medium",
  "tertiary-title-regular",
  "headline-bold",
  "headline-medium",
  "primary-text-bold",
  "primary-text-medium",
  "primary-text-regular",
  "secondary-text-bold",
  "secondary-text-medium",
  "secondary-text-regular",
  "caption-bold",
  "caption-medium",
  "caption-regular",
  "small-caption-bold",
  "small-caption-medium",
  "small-caption-regular"
], Ur = ["start", "center", "end", "justify"], Kr = [
  "primary",
  "secondary",
  "tertiary",
  "negative",
  "positive",
  "primary-foreground"
], Jr = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "li",
  "span",
  "div",
  "th",
  "td"
], po = [
  "arrow-left",
  "arrow-line-back",
  "arrow-right",
  "bank-id",
  "book",
  "business",
  "calendar",
  "card-view",
  "caret-down",
  "caret-left",
  "caret-right",
  "caret-up",
  "check-circle",
  "checkbox-filled",
  "checkbox-indeterminate",
  "checkbox",
  "checkmark",
  "code",
  "copy",
  "cross-circle-filled",
  "cross",
  "divide",
  "document",
  "double-chevron-down",
  "download",
  "equals",
  "exclamation-circle",
  "external-link",
  "eye",
  "fb",
  "feedback",
  "filter",
  "flag-en",
  "flag-sv",
  "gitlab",
  "info-circle",
  "insta",
  "licence",
  "lightning-bolt",
  "linkedin",
  "list-view",
  "list",
  "lock-locked",
  "lock-unlocked",
  "log-out",
  "menu",
  "message",
  "minus-circle",
  "minus",
  "moon",
  "phone",
  "play-circle",
  "plus-circle",
  "plus",
  "print",
  "profile",
  "qr",
  "question-mark",
  "question-mark-circle",
  "radio-filled",
  "radio",
  "refund",
  "request",
  "search",
  "settings",
  "shopping-bag-filled",
  "sun",
  "swap",
  "swish-minimal",
  "thumb-down-filled",
  "thumb-down-outlined",
  "thumb-up-filled",
  "thumb-up-outlined",
  "timer-circle",
  "trash-can",
  "twitter",
  "users",
  "user-add",
  "wallet",
  "website",
  "youtube"
], Gr = po.filter(
  (a) => !["gitlab", "flag-en", "flag-sv"].includes(a)
), Zr = ["small", "large", "huge"], Qr = ["light", "dark"], Xr = [
  "swish-logo",
  "swish-business-logo-en",
  "swish-business-logo-sv",
  "bank-id",
  "dialog-empty",
  "dialog-warning",
  "dialog-information",
  "dialog-broken",
  "emoji-bad",
  "emoji-bad-color",
  "emoji-good",
  "emoji-good-color",
  "emoji-ok",
  "emoji-ok-color",
  "heart",
  "confirmation-checkmark",
  "confirmation-checkmark-blue"
], es = [
  "blue",
  "teal",
  "pink",
  "purple",
  "light-blue",
  "magenta",
  "orange",
  "red",
  "yellow",
  "green",
  "grey",
  "light-grey"
], ts = ["small", "regular"], ns = ["start", "center", "end"], as = ["up", "down"], is = ["none", "both", "horizontal", "vertical"], os = ["default", "tall"], mo = (a, n) => {
  const e = a[n];
  return e ? typeof e == "function" ? e() : Promise.resolve(e) : new Promise((r, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(s.bind(null, new Error("Unknown variable dynamic import: " + n)));
  });
}, go = { class: "svg-wrapper" }, ho = /* @__PURE__ */ O({
  __name: "SwSvg",
  props: {
    name: {},
    directory: {},
    width: {},
    height: {},
    color: {}
  },
  setup(a) {
    ln((l) => ({
      "0d32d602": r.value,
      "49c79b9b": e.value,
      "503c53d0": l.color
    }));
    const n = a, e = H(() => `${n.width}px`), r = H(() => `${n.height}px`), s = cn();
    return Pe(
      [() => n.name, () => n.directory],
      () => {
        s.value = un(
          () => mo(/* @__PURE__ */ Object.assign({ "../assets/graphics/bank-id.svg": () => import("./bank-id-ZVu_uO2w.js"), "../assets/graphics/confirmation-checkmark-blue.svg": () => import("./confirmation-checkmark-blue-Rj6vCApP.js"), "../assets/graphics/confirmation-checkmark.svg": () => import("./confirmation-checkmark-GdqJqCnB.js"), "../assets/graphics/dialog-broken.svg": () => import("./dialog-broken-Z6TCTcyz.js"), "../assets/graphics/dialog-empty.svg": () => import("./dialog-empty-zyRTZUV4.js"), "../assets/graphics/dialog-information.svg": () => import("./dialog-information-V4uAYQYt.js"), "../assets/graphics/dialog-warning.svg": () => import("./dialog-warning-HNRQb-JD.js"), "../assets/graphics/emoji-bad-color.svg": () => import("./emoji-bad-color-ep796c2F.js"), "../assets/graphics/emoji-bad.svg": () => import("./emoji-bad-4qG0NJtS.js"), "../assets/graphics/emoji-good-color.svg": () => import("./emoji-good-color-dJW-e1bz.js"), "../assets/graphics/emoji-good.svg": () => import("./emoji-good-d_GeNmRZ.js"), "../assets/graphics/emoji-ok-color.svg": () => import("./emoji-ok-color-Sio480vF.js"), "../assets/graphics/emoji-ok.svg": () => import("./emoji-ok-julTuVDd.js"), "../assets/graphics/heart.svg": () => import("./heart-dE4kDC8K.js"), "../assets/graphics/swish-business-logo-en.svg": () => import("./swish-business-logo-en-lDRCb9Lx.js"), "../assets/graphics/swish-business-logo-sv.svg": () => import("./swish-business-logo-sv-2AOyakqB.js"), "../assets/graphics/swish-logo.svg": () => import("./swish-logo-KRfwokf3.js"), "../assets/icons/arrow-left.svg": () => import("./arrow-left-IxfC6LSL.js"), "../assets/icons/arrow-line-back.svg": () => import("./arrow-line-back-etyT_vLW.js"), "../assets/icons/arrow-right.svg": () => import("./arrow-right-Lwjyenlh.js"), "../assets/icons/bank-id.svg": () => import("./bank-id-HaXLgrrn.js"), "../assets/icons/book.svg": () => import("./book-xqoMwLsC.js"), "../assets/icons/business.svg": () => import("./business-i5uRjYUp.js"), "../assets/icons/calendar.svg": () => import("./calendar-ochLhdk5.js"), "../assets/icons/card-view.svg": () => import("./card-view-6lF8UVFi.js"), "../assets/icons/caret-down.svg": () => import("./caret-down-lm99Wsgv.js"), "../assets/icons/caret-left.svg": () => import("./caret-left-aec_LkbC.js"), "../assets/icons/caret-right.svg": () => import("./caret-right-VN5ydtPj.js"), "../assets/icons/caret-up.svg": () => import("./caret-up-nAd-OPWe.js"), "../assets/icons/check-circle.svg": () => import("./check-circle-rRBeoiGz.js"), "../assets/icons/checkbox-filled.svg": () => import("./checkbox-filled-_6KseZAE.js"), "../assets/icons/checkbox-indeterminate.svg": () => import("./checkbox-indeterminate-pmGmTn4Q.js"), "../assets/icons/checkbox.svg": () => import("./checkbox-vrbc3EQv.js"), "../assets/icons/checkmark.svg": () => import("./checkmark-b3aMrhuS.js"), "../assets/icons/code.svg": () => import("./code-r72SBHQE.js"), "../assets/icons/copy.svg": () => import("./copy-wIm0OfpR.js"), "../assets/icons/cross-circle-filled.svg": () => import("./cross-circle-filled-SA3UcyEi.js"), "../assets/icons/cross.svg": () => import("./cross-qtAelPN8.js"), "../assets/icons/divide.svg": () => import("./divide-OyskA_vY.js"), "../assets/icons/document.svg": () => import("./document-6dR_Xm5q.js"), "../assets/icons/double-chevron-down.svg": () => import("./double-chevron-down-SUA_0E7b.js"), "../assets/icons/download.svg": () => import("./download-sYJl0LzT.js"), "../assets/icons/equals.svg": () => import("./equals-1tbwahdW.js"), "../assets/icons/exclamation-circle.svg": () => import("./exclamation-circle-lJ4JSQmB.js"), "../assets/icons/external-link.svg": () => import("./external-link-HdYfcomb.js"), "../assets/icons/eye.svg": () => import("./eye-xoBMVa18.js"), "../assets/icons/fb.svg": () => import("./fb-TnpwzjOq.js"), "../assets/icons/feedback.svg": () => import("./feedback-Y5btDHBI.js"), "../assets/icons/filter.svg": () => import("./filter-BPYvcRV9.js"), "../assets/icons/flag-en.svg": () => import("./flag-en-OrI7C9OV.js"), "../assets/icons/flag-sv.svg": () => import("./flag-sv--0g4m4Vz.js"), "../assets/icons/gitlab.svg": () => import("./gitlab-amiQjSXY.js"), "../assets/icons/info-circle.svg": () => import("./info-circle-llEhWqMs.js"), "../assets/icons/insta.svg": () => import("./insta-_ahs7ebE.js"), "../assets/icons/licence.svg": () => import("./licence-Pn9GDFIK.js"), "../assets/icons/lightning-bolt.svg": () => import("./lightning-bolt-1beIOYqK.js"), "../assets/icons/linkedin.svg": () => import("./linkedin-pQW6SaM8.js"), "../assets/icons/list-view.svg": () => import("./list-view-1by_JOaC.js"), "../assets/icons/list.svg": () => import("./list-XukLl64l.js"), "../assets/icons/lock-locked.svg": () => import("./lock-locked-Vv0lVNt0.js"), "../assets/icons/lock-unlocked.svg": () => import("./lock-unlocked-xCBxWiCj.js"), "../assets/icons/log-out.svg": () => import("./log-out-u54ublIZ.js"), "../assets/icons/menu.svg": () => import("./menu-AAov6jXv.js"), "../assets/icons/message.svg": () => import("./message-4cwawpJ7.js"), "../assets/icons/minus-circle.svg": () => import("./minus-circle-qBMuugyl.js"), "../assets/icons/minus.svg": () => import("./minus-4iLR81Jp.js"), "../assets/icons/moon.svg": () => import("./moon-fmlCC8O9.js"), "../assets/icons/phone.svg": () => import("./phone-IpbKPOLm.js"), "../assets/icons/play-circle.svg": () => import("./play-circle-u3V36U1W.js"), "../assets/icons/plus-circle.svg": () => import("./plus-circle-E2waz62S.js"), "../assets/icons/plus.svg": () => import("./plus-Q7ZeEKAn.js"), "../assets/icons/print.svg": () => import("./print-pCh-0jiT.js"), "../assets/icons/profile.svg": () => import("./profile-SXD5tSwn.js"), "../assets/icons/qr.svg": () => import("./qr-5AvzKdpB.js"), "../assets/icons/question-mark-circle.svg": () => import("./question-mark-circle-KPe-IDOn.js"), "../assets/icons/question-mark.svg": () => import("./question-mark-DGqL4RnU.js"), "../assets/icons/radio-filled.svg": () => import("./radio-filled-bnBH7yRF.js"), "../assets/icons/radio.svg": () => import("./radio-tneXfyeJ.js"), "../assets/icons/refund.svg": () => import("./refund-En_P-NKQ.js"), "../assets/icons/request.svg": () => import("./request-qiEUpc1Y.js"), "../assets/icons/search.svg": () => import("./search-rovy7khy.js"), "../assets/icons/settings.svg": () => import("./settings-oGrEQmHd.js"), "../assets/icons/shopping-bag-filled.svg": () => import("./shopping-bag-filled-gCaxqcrz.js"), "../assets/icons/sun.svg": () => import("./sun-B4llypdk.js"), "../assets/icons/swap.svg": () => import("./swap-PT-2dm4v.js"), "../assets/icons/swish-minimal.svg": () => import("./swish-minimal-ayQF-u5y.js"), "../assets/icons/thumb-down-filled.svg": () => import("./thumb-down-filled-DM9kGhvC.js"), "../assets/icons/thumb-down-outlined.svg": () => import("./thumb-down-outlined-VNWrHcBL.js"), "../assets/icons/thumb-up-filled.svg": () => import("./thumb-up-filled-EggiOpTj.js"), "../assets/icons/thumb-up-outlined.svg": () => import("./thumb-up-outlined-b1Nq_b7d.js"), "../assets/icons/timer-circle.svg": () => import("./timer-circle-hS4zJSsd.js"), "../assets/icons/trash-can.svg": () => import("./trash-can-8LzW3L0s.js"), "../assets/icons/twitter.svg": () => import("./twitter-5ek29Cbv.js"), "../assets/icons/user-add.svg": () => import("./user-add-bXtcqHMS.js"), "../assets/icons/users.svg": () => import("./users-y-tAaHc5.js"), "../assets/icons/wallet.svg": () => import("./wallet-Fl0KFIQu.js"), "../assets/icons/website.svg": () => import("./website-4tLoUGim.js"), "../assets/icons/youtube.svg": () => import("./youtube-jNUZShNH.js") }), `../assets/${n.directory}/${n.name}.svg`)
        );
      },
      { immediate: !0 }
    ), (l, f) => (D(), x("div", go, [
      (D(), W(Fe(s.value), {
        class: B({ "svg-custom-color": l.color }),
        width: l.width,
        height: l.height
      }, null, 8, ["class", "width", "height"]))
    ]));
  }
}), z = (a, n) => {
  const e = a.__vccOpts || a;
  for (const [r, s] of n)
    e[r] = s;
  return e;
}, Tt = /* @__PURE__ */ z(ho, [["__scopeId", "data-v-f016eda0"]]), ee = /* @__PURE__ */ O({
  __name: "SwSvgIcon",
  props: {
    name: {},
    width: { default: 24 },
    height: {},
    color: {}
  },
  setup(a) {
    const n = a, e = H(() => n.height || n.width);
    return (r, s) => (D(), W(Tt, {
      name: r.name,
      directory: "icons",
      width: r.width,
      height: e.value,
      color: r.color
    }, null, 8, ["name", "width", "height", "color"]));
  }
}), rs = /* @__PURE__ */ O({
  __name: "SwSvgGraphic",
  props: {
    name: {},
    width: {},
    height: {}
  },
  setup(a) {
    return (n, e) => (D(), W(Tt, {
      name: n.name,
      directory: "graphics",
      width: n.width,
      height: n.height
    }, null, 8, ["name", "width", "height"]));
  }
}), vo = /* @__PURE__ */ O({
  __name: "SwLinkButton",
  props: {
    label: {},
    smallText: { type: Boolean, default: !1 },
    leftIcon: {},
    rightIcon: {},
    element: { default: "button" },
    href: {}
  },
  setup(a) {
    const n = a, e = H(() => ({
      link: !0,
      "text-sm": n.smallText
    })), r = H(() => n.smallText ? 20 : 24);
    return (s, l) => (D(), W(Fe(s.element), {
      class: B(e.value),
      href: s.element === "a" ? s.href : void 0,
      type: s.element === "button" ? "button" : void 0
    }, {
      default: re(() => [
        s.leftIcon ? (D(), W(ee, {
          key: 0,
          name: s.leftIcon,
          width: r.value,
          color: he($).ghostButtonLabel
        }, null, 8, ["name", "width", "color"])) : R("", !0),
        et(" " + U(n.label) + " ", 1),
        s.rightIcon ? (D(), W(ee, {
          key: 1,
          name: s.rightIcon,
          width: r.value,
          color: he($).ghostButtonLabel
        }, null, 8, ["name", "width", "color"])) : R("", !0)
      ]),
      _: 1
    }, 8, ["class", "href", "type"]));
  }
}), ss = /* @__PURE__ */ z(vo, [["__scopeId", "data-v-ec352ec2"]]), yo = /* @__PURE__ */ O({
  __name: "SwLoadingDots",
  props: {
    size: { default: "large" },
    color: { default: "light" }
  },
  setup(a) {
    return (n, e) => (D(), x("div", {
      class: B(["dots", n.size])
    }, [
      F("div", {
        class: B(["dot bounce", [n.size, n.color]])
      }, null, 2),
      F("div", {
        class: B(["dot bounce bounce-1", [n.size, n.color]])
      }, null, 2),
      F("div", {
        class: B(["dot bounce bounce-2", [n.size, n.color]])
      }, null, 2)
    ], 2));
  }
}), bo = /* @__PURE__ */ z(yo, [["__scopeId", "data-v-3af83597"]]), wo = { key: 2 }, Do = { key: 5 }, ko = /* @__PURE__ */ O({
  __name: "SwButton",
  props: {
    label: {},
    variant: { default: "primary" },
    size: { default: "hug" },
    leftIcon: {},
    rightIcon: {},
    isLoading: { type: Boolean },
    element: { default: "button" },
    href: {}
  },
  emits: ["click"],
  setup(a, { emit: n }) {
    const e = a, r = n, s = () => r("click"), l = H(() => ({
      button: !0,
      [e.variant]: !0,
      [e.size]: !0,
      "has-left-icon": e.leftIcon,
      "has-right-icon": e.rightIcon
    })), f = H(() => e.variant === "primary" ? "light" : "dark"), m = {
      primary: $.primaryButtonLabel,
      secondary: $.secondaryButtonLabel,
      tertiary: $.tertiaryButtonLabel,
      ghost: $.ghostButtonLabel
    }, u = H(() => e.isLoading ? "transparent" : m[e.variant]);
    return (v, y) => (D(), W(Fe(v.element), {
      type: v.element === "button" ? "button" : void 0,
      class: B(l.value),
      onClick: s,
      disabled: v.isLoading,
      "aria-label": v.label,
      href: v.element === "a" ? v.href : void 0
    }, {
      default: re(() => [
        v.isLoading ? (D(), W(bo, {
          key: 0,
          class: "loading-dots",
          color: f.value,
          size: "small"
        }, null, 8, ["color"])) : R("", !0),
        v.leftIcon ? (D(), W(ee, {
          key: 1,
          class: "left-icon",
          name: v.leftIcon,
          width: 24,
          color: u.value
        }, null, 8, ["name", "color"])) : (D(), x("div", wo)),
        v.size !== "icon-only" ? (D(), x("div", {
          key: 3,
          style: Oe({ color: u.value })
        }, U(e.label), 5)) : R("", !0),
        v.rightIcon ? (D(), W(ee, {
          key: 4,
          class: "right-icon",
          name: v.rightIcon,
          width: 24,
          color: u.value
        }, null, 8, ["name", "color"])) : (D(), x("div", Do))
      ]),
      _: 1
    }, 8, ["type", "class", "disabled", "aria-label", "href"]));
  }
}), ls = /* @__PURE__ */ z(ko, [["__scopeId", "data-v-614fef61"]]), Mo = ["aria-label"], Co = { class: "label" }, To = /* @__PURE__ */ O({
  __name: "SwSmallButton",
  props: {
    label: {},
    variant: { default: "default" },
    leftIcon: {},
    rightIcon: {}
  },
  emits: ["click"],
  setup(a, { emit: n }) {
    const e = a, r = n, s = () => r("click"), l = H(() => ({
      button: !0,
      [e.variant]: !0
    })), f = {
      default: $.smallButtonLabel,
      tertiary: $.tertiaryButtonLabel,
      ghost: $.ghostButtonLabel,
      negative: $.negativeAlertLabel,
      positive: $.positiveAlertLabel
    }, m = H(() => f[e.variant]);
    return (u, v) => (D(), x("button", {
      type: "button",
      class: B(l.value),
      onClick: s,
      "aria-label": u.label
    }, [
      u.leftIcon ? (D(), W(ee, {
        key: 0,
        class: "left-icon",
        name: u.leftIcon,
        width: 24,
        color: m.value
      }, null, 8, ["name", "color"])) : R("", !0),
      F("div", Co, U(e.label), 1),
      u.rightIcon ? (D(), W(ee, {
        key: 1,
        class: "right-icon",
        name: u.rightIcon,
        width: 24,
        color: m.value
      }, null, 8, ["name", "color"])) : R("", !0)
    ], 10, Mo));
  }
}), cs = /* @__PURE__ */ z(To, [["__scopeId", "data-v-1ddbac50"]]), So = /* @__PURE__ */ O({
  __name: "SwIconButton",
  props: {
    iconName: {},
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(a, { emit: n }) {
    const e = a, r = n, s = () => r("click"), l = H(() => ({
      button: !0,
      [e.variant]: !0
    })), f = {
      primary: $.primaryForeground,
      secondary: $.secondaryForeground,
      tertiary: $.tertiaryForeground
    }, m = H(() => f[e.variant]);
    return (u, v) => (D(), x("button", {
      type: "button",
      class: B(l.value),
      onClick: s
    }, [
      Me(ee, {
        name: u.iconName,
        width: 24,
        color: m.value
      }, null, 8, ["name", "color"])
    ], 2));
  }
}), _o = /* @__PURE__ */ z(So, [["__scopeId", "data-v-a8ec681e"]]), Eo = { class: "radio-button-container" }, xo = ["id"], Io = ["for"], gt = 24, Bo = {
  inheritAttrs: !1
}, Ao = /* @__PURE__ */ O({
  ...Bo,
  __name: "SwRadioButton",
  props: {
    modelValue: {},
    id: {},
    label: {},
    width: { default: gt }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: n }) {
    const e = a, r = n, s = H({
      get: () => e.modelValue,
      set: (l) => r("update:modelValue", l)
    });
    return (l, f) => (D(), x("div", Eo, [
      tt(F("input", ve(l.$attrs, {
        "onUpdate:modelValue": f[0] || (f[0] = (m) => s.value = m),
        type: "radio",
        class: "radio-button",
        style: `--width: ${l.width * 0.0625}rem`,
        id: l.id
      }), null, 16, xo), [
        [dn, s.value]
      ]),
      l.label ? (D(), x("label", {
        key: 0,
        for: l.id,
        style: Oe(`--size-multiplier: ${l.width / gt}`)
      }, U(l.label), 13, Io)) : R("", !0)
    ]));
  }
}), us = /* @__PURE__ */ z(Ao, [["__scopeId", "data-v-f6d5cdce"]]), Ho = { class: "checkbox-container" }, Po = ["checked", "id", "indeterminate"], Lo = ["for"], ht = 24, Fo = {
  inheritAttrs: !1
}, Oo = /* @__PURE__ */ O({
  ...Fo,
  __name: "SwCheckbox",
  props: {
    modelValue: { type: Boolean },
    id: {},
    label: {},
    width: { default: ht },
    indeterminate: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: n }) {
    const e = a, r = n, s = oe();
    return Pe(
      () => e.indeterminate,
      (l) => {
        s.value.indeterminate = l;
      }
    ), (l, f) => (D(), x("div", Ho, [
      F("input", ve(l.$attrs, {
        checked: l.modelValue,
        onInput: f[0] || (f[0] = (m) => r("update:modelValue", !l.modelValue)),
        type: "checkbox",
        class: "checkbox",
        style: `--width: ${l.width * 0.0625}rem`,
        id: l.id,
        ref: (m) => s.value = m,
        indeterminate: l.indeterminate
      }), null, 16, Po),
      l.label ? (D(), x("label", {
        key: 0,
        for: l.id,
        style: Oe(`--size-multiplier: ${l.width / ht}`)
      }, U(l.label), 13, Lo)) : R("", !0)
    ]));
  }
}), ds = /* @__PURE__ */ z(Oo, [["__scopeId", "data-v-9afb8a0d"]]), No = (a) => (kt("data-v-20b76225"), a = a(), Mt(), a), Wo = { class: "toggle-container" }, Ro = ["checked", "id"], Yo = /* @__PURE__ */ No(() => /* @__PURE__ */ F("div", { class: "hover-element" }, null, -1)), $o = ["for"], zo = {
  inheritAttrs: !1
}, jo = /* @__PURE__ */ O({
  ...zo,
  __name: "SwToggle",
  props: {
    label: {},
    id: {},
    modelValue: { type: Boolean },
    showLock: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: n }) {
    const e = n;
    return (r, s) => (D(), x("div", Wo, [
      F("input", ve(r.$attrs, {
        checked: r.modelValue,
        onInput: s[0] || (s[0] = (l) => e("update:modelValue", !r.modelValue)),
        type: "checkbox",
        class: ["toggle", { "show-lock": r.showLock }],
        id: r.id
      }), null, 16, Ro),
      Yo,
      r.label && r.id ? (D(), x("label", {
        key: 0,
        for: r.id
      }, U(r.label), 9, $o)) : R("", !0)
    ]));
  }
}), fs = /* @__PURE__ */ z(jo, [["__scopeId", "data-v-20b76225"]]), Vo = /* @__PURE__ */ O({
  __name: "SwText",
  props: {
    variant: { default: "primary-text-regular" },
    element: { default: "p" },
    align: { default: "start" },
    color: { default: "primary" }
  },
  setup(a) {
    const n = a, e = H(() => ({
      [n.variant]: !0,
      [n.color]: !0,
      [n.align]: !0
    }));
    return (r, s) => (D(), W(Fe(r.element), {
      class: B(e.value)
    }, {
      default: re(() => [
        le(r.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), nt = /* @__PURE__ */ z(Vo, [["__scopeId", "data-v-83426650"]]), qo = { class: "label-wrapper" }, Uo = ["for"], Ko = ["id", "disabled", "placeholder", "cols", "rows"], Jo = /* @__PURE__ */ O({
  __name: "SwTextArea",
  props: {
    id: {},
    label: {},
    modelValue: {},
    disabled: { type: Boolean },
    error: { type: Boolean },
    errorText: {},
    fullWidth: { type: Boolean },
    placeholderText: {},
    helperText: {},
    hideLabel: { type: Boolean },
    maxCount: {},
    resize: { default: "none" },
    cols: { default: 40 },
    rows: { default: 4 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: n }) {
    const e = a, r = n, s = H({
      get: () => e.modelValue,
      set: (u) => r("update:modelValue", u)
    }), l = H(() => e.error ? e.errorText : e.helperText), f = H(
      () => e.maxCount !== void 0 && s.value.length > e.maxCount
    ), m = H(() => ({
      error: e.error || f.value,
      disabled: e.disabled,
      "full-width": e.fullWidth
    }));
    return (u, v) => (D(), x("div", {
      class: B(["textarea-wrapper", m.value])
    }, [
      F("div", qo, [
        F("label", {
          class: B(["label", { hidden: u.hideLabel, disabled: e.disabled }]),
          for: u.id
        }, U(u.label), 11, Uo),
        u.maxCount !== void 0 ? (D(), x("span", {
          key: 0,
          class: B(["character-count", m.value])
        }, U(u.modelValue.length) + "/" + U(u.maxCount), 3)) : R("", !0)
      ]),
      tt(F("textarea", {
        id: u.id,
        "onUpdate:modelValue": v[0] || (v[0] = (y) => s.value = y),
        class: B(["textarea", m.value]),
        disabled: u.disabled,
        placeholder: u.placeholderText,
        cols: u.cols,
        rows: u.rows,
        style: Oe(`resize: ${u.resize}`)
      }, null, 14, Ko), [
        [fn, s.value]
      ]),
      u.helperText || u.errorText ? (D(), x("span", {
        key: 0,
        class: B(["helper-text", m.value])
      }, U(l.value), 3)) : R("", !0)
    ], 2));
  }
}), ps = /* @__PURE__ */ z(Jo, [["__scopeId", "data-v-e1c50b66"]]), Go = ["for"], Zo = ["id", "value", "disabled", "spellcheck"], Qo = {
  key: 0,
  class: "suffix"
}, Xo = {
  inheritAttrs: !1
}, er = /* @__PURE__ */ O({
  ...Xo,
  __name: "SwTextInput",
  props: {
    id: {},
    label: {},
    modelValue: {},
    disabled: { type: Boolean },
    error: { type: Boolean },
    errorText: {},
    fullWidth: { type: Boolean, default: !1 },
    helperText: {},
    hideLabel: { type: Boolean },
    spellcheck: { type: Boolean, default: !1 },
    suffix: {},
    icon: {}
  },
  emits: ["update:modelValue"],
  setup(a, { expose: n, emit: e }) {
    const r = a, s = e, l = oe(), f = () => {
      var v;
      (v = l.value) == null || v.focus();
    };
    n({ focus: f });
    const m = H(() => r.error ? r.errorText : r.helperText), u = H(() => ({
      error: r.error,
      disabled: r.disabled,
      "full-width": r.fullWidth
    }));
    return (v, y) => (D(), x("div", {
      class: B(["input-wrapper", u.value])
    }, [
      v.hideLabel ? R("", !0) : (D(), x("label", {
        key: 0,
        for: v.id,
        class: B(["label", u.value])
      }, U(v.label), 11, Go)),
      F("div", {
        class: B(["input", u.value]),
        onClick: f
      }, [
        F("input", ve({
          id: v.id,
          ref_key: "inputRef",
          ref: l,
          class: ["input-field", u.value],
          value: v.modelValue,
          disabled: v.disabled
        }, v.$attrs, {
          spellcheck: v.spellcheck,
          onInput: y[0] || (y[0] = (C) => s("update:modelValue", C.target.value))
        }), null, 16, Zo),
        v.suffix ? (D(), x("span", Qo, U(v.suffix), 1)) : R("", !0),
        v.icon ? (D(), W(ee, {
          key: 1,
          class: "suffix",
          name: v.icon,
          color: he($).primaryInteraction
        }, null, 8, ["name", "color"])) : R("", !0)
      ], 2),
      v.helperText || v.errorText ? (D(), x("span", {
        key: 1,
        class: B(["helper-text", u.value])
      }, U(m.value), 3)) : R("", !0)
    ], 2));
  }
}), tr = /* @__PURE__ */ z(er, [["__scopeId", "data-v-33120f6f"]]), nr = (a) => (kt("data-v-ce673116"), a = a(), Mt(), a), ar = /* @__PURE__ */ nr(() => /* @__PURE__ */ F("div", { class: "tooltip-padding" }, null, -1)), ir = /* @__PURE__ */ O({
  __name: "SwTooltip",
  props: {
    align: { default: "center" },
    direction: { default: "up" },
    visible: { type: Boolean, default: !1 },
    visibleOnHover: { type: Boolean, default: !1 }
  },
  setup(a) {
    return (n, e) => (D(), x("div", {
      class: B(["tooltip-container", { "visible-on-hover": n.visibleOnHover, visible: n.visible }])
    }, [
      le(n.$slots, "default", {}, void 0, !0),
      F("div", {
        class: B(`tooltip ${n.align} ${n.direction}`)
      }, [
        Me(nt, {
          variant: "caption-medium",
          element: "div",
          class: "tooltip-text",
          color: "tertiary"
        }, {
          default: re(() => [
            le(n.$slots, "tooltip", {}, void 0, !0)
          ]),
          _: 3
        }),
        ar
      ], 2)
    ], 2));
  }
}), or = /* @__PURE__ */ z(ir, [["__scopeId", "data-v-ce673116"]]), rr = {
  inheritAttrs: !1
}, ms = /* @__PURE__ */ O({
  ...rr,
  __name: "SwTextTooltip",
  props: {
    variant: {},
    element: {},
    align: {},
    color: {},
    tooltipAlign: {},
    tooltipDirection: {}
  },
  setup(a) {
    return (n, e) => (D(), W(or, {
      align: n.tooltipAlign,
      direction: n.tooltipDirection,
      "visible-on-hover": !0
    }, {
      default: re(() => [
        Me(nt, ve({
          variant: n.variant,
          element: "div",
          align: n.align,
          color: n.color
        }, n.$attrs), {
          default: re(() => [
            le(n.$slots, "default")
          ]),
          _: 3
        }, 16, ["variant", "align", "color"])
      ]),
      tooltip: re(() => [
        le(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["align", "direction"]));
  }
});
var qe = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], me = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(a) {
    return typeof console < "u" && console.warn(a);
  },
  getWeek: function(a) {
    var n = new Date(a.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var e = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - e.getTime()) / 864e5 - 3 + (e.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, Ce = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(a) {
    var n = a % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, K = function(a, n) {
  return n === void 0 && (n = 2), ("000" + a).slice(n * -1);
}, Q = function(a) {
  return a === !0 ? 1 : 0;
};
function vt(a, n) {
  var e;
  return function() {
    var r = this, s = arguments;
    clearTimeout(e), e = setTimeout(function() {
      return a.apply(r, s);
    }, n);
  };
}
var Ue = function(a) {
  return a instanceof Array ? a : [a];
};
function q(a, n, e) {
  if (e === !0)
    return a.classList.add(n);
  a.classList.remove(n);
}
function _(a, n, e) {
  var r = window.document.createElement(a);
  return n = n || "", e = e || "", r.className = n, e !== void 0 && (r.textContent = e), r;
}
function Ae(a) {
  for (; a.firstChild; )
    a.removeChild(a.firstChild);
}
function St(a, n) {
  if (n(a))
    return a;
  if (a.parentNode)
    return St(a.parentNode, n);
}
function He(a, n) {
  var e = _("div", "numInputWrapper"), r = _("input", "numInput " + a), s = _("span", "arrowUp"), l = _("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? r.type = "number" : (r.type = "text", r.pattern = "\\d*"), n !== void 0)
    for (var f in n)
      r.setAttribute(f, n[f]);
  return e.appendChild(r), e.appendChild(s), e.appendChild(l), e;
}
function G(a) {
  try {
    if (typeof a.composedPath == "function") {
      var n = a.composedPath();
      return n[0];
    }
    return a.target;
  } catch {
    return a.target;
  }
}
var Ke = function() {
}, Le = function(a, n, e) {
  return e.months[n ? "shorthand" : "longhand"][a];
}, sr = {
  D: Ke,
  F: function(a, n, e) {
    a.setMonth(e.months.longhand.indexOf(n));
  },
  G: function(a, n) {
    a.setHours((a.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  H: function(a, n) {
    a.setHours(parseFloat(n));
  },
  J: function(a, n) {
    a.setDate(parseFloat(n));
  },
  K: function(a, n, e) {
    a.setHours(a.getHours() % 12 + 12 * Q(new RegExp(e.amPM[1], "i").test(n)));
  },
  M: function(a, n, e) {
    a.setMonth(e.months.shorthand.indexOf(n));
  },
  S: function(a, n) {
    a.setSeconds(parseFloat(n));
  },
  U: function(a, n) {
    return new Date(parseFloat(n) * 1e3);
  },
  W: function(a, n, e) {
    var r = parseInt(n), s = new Date(a.getFullYear(), 0, 2 + (r - 1) * 7, 0, 0, 0, 0);
    return s.setDate(s.getDate() - s.getDay() + e.firstDayOfWeek), s;
  },
  Y: function(a, n) {
    a.setFullYear(parseFloat(n));
  },
  Z: function(a, n) {
    return new Date(n);
  },
  d: function(a, n) {
    a.setDate(parseFloat(n));
  },
  h: function(a, n) {
    a.setHours((a.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  i: function(a, n) {
    a.setMinutes(parseFloat(n));
  },
  j: function(a, n) {
    a.setDate(parseFloat(n));
  },
  l: Ke,
  m: function(a, n) {
    a.setMonth(parseFloat(n) - 1);
  },
  n: function(a, n) {
    a.setMonth(parseFloat(n) - 1);
  },
  s: function(a, n) {
    a.setSeconds(parseFloat(n));
  },
  u: function(a, n) {
    return new Date(parseFloat(n));
  },
  w: Ke,
  y: function(a, n) {
    a.setFullYear(2e3 + parseFloat(n));
  }
}, ue = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, De = {
  Z: function(a) {
    return a.toISOString();
  },
  D: function(a, n, e) {
    return n.weekdays.shorthand[De.w(a, n, e)];
  },
  F: function(a, n, e) {
    return Le(De.n(a, n, e) - 1, !1, n);
  },
  G: function(a, n, e) {
    return K(De.h(a, n, e));
  },
  H: function(a) {
    return K(a.getHours());
  },
  J: function(a, n) {
    return n.ordinal !== void 0 ? a.getDate() + n.ordinal(a.getDate()) : a.getDate();
  },
  K: function(a, n) {
    return n.amPM[Q(a.getHours() > 11)];
  },
  M: function(a, n) {
    return Le(a.getMonth(), !0, n);
  },
  S: function(a) {
    return K(a.getSeconds());
  },
  U: function(a) {
    return a.getTime() / 1e3;
  },
  W: function(a, n, e) {
    return e.getWeek(a);
  },
  Y: function(a) {
    return K(a.getFullYear(), 4);
  },
  d: function(a) {
    return K(a.getDate());
  },
  h: function(a) {
    return a.getHours() % 12 ? a.getHours() % 12 : 12;
  },
  i: function(a) {
    return K(a.getMinutes());
  },
  j: function(a) {
    return a.getDate();
  },
  l: function(a, n) {
    return n.weekdays.longhand[a.getDay()];
  },
  m: function(a) {
    return K(a.getMonth() + 1);
  },
  n: function(a) {
    return a.getMonth() + 1;
  },
  s: function(a) {
    return a.getSeconds();
  },
  u: function(a) {
    return a.getTime();
  },
  w: function(a) {
    return a.getDay();
  },
  y: function(a) {
    return String(a.getFullYear()).substring(2);
  }
}, _t = function(a) {
  var n = a.config, e = n === void 0 ? me : n, r = a.l10n, s = r === void 0 ? Ce : r, l = a.isMobile, f = l === void 0 ? !1 : l;
  return function(m, u, v) {
    var y = v || s;
    return e.formatDate !== void 0 && !f ? e.formatDate(m, u, y) : u.split("").map(function(C, P, V) {
      return De[C] && V[P - 1] !== "\\" ? De[C](m, y, e) : C !== "\\" ? C : "";
    }).join("");
  };
}, Qe = function(a) {
  var n = a.config, e = n === void 0 ? me : n, r = a.l10n, s = r === void 0 ? Ce : r;
  return function(l, f, m, u) {
    if (!(l !== 0 && !l)) {
      var v = u || s, y, C = l;
      if (l instanceof Date)
        y = new Date(l.getTime());
      else if (typeof l != "string" && l.toFixed !== void 0)
        y = new Date(l);
      else if (typeof l == "string") {
        var P = f || (e || me).dateFormat, V = String(l).trim();
        if (V === "today")
          y = /* @__PURE__ */ new Date(), m = !0;
        else if (e && e.parseDate)
          y = e.parseDate(l, P);
        else if (/Z$/.test(V) || /GMT$/.test(V))
          y = new Date(l);
        else {
          for (var te = void 0, S = [], k = 0, w = 0, I = ""; k < P.length; k++) {
            var Y = P[k], L = Y === "\\", se = P[k - 1] === "\\" || L;
            if (ue[Y] && !se) {
              I += ue[Y];
              var ne = new RegExp(I).exec(l);
              ne && (te = !0) && S[Y !== "Y" ? "push" : "unshift"]({
                fn: sr[Y],
                val: ne[++w]
              });
            } else
              L || (I += ".");
          }
          y = !e || !e.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), S.forEach(function(ae) {
            var de = ae.fn, Ne = ae.val;
            return y = de(y, Ne, v) || y;
          }), y = te ? y : void 0;
        }
      }
      if (!(y instanceof Date && !isNaN(y.getTime()))) {
        e.errorHandler(new Error("Invalid date provided: " + C));
        return;
      }
      return m === !0 && y.setHours(0, 0, 0, 0), y;
    }
  };
};
function Z(a, n, e) {
  return e === void 0 && (e = !0), e !== !1 ? new Date(a.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : a.getTime() - n.getTime();
}
var lr = function(a, n, e) {
  return a > Math.min(n, e) && a < Math.max(n, e);
}, Je = function(a, n, e) {
  return a * 3600 + n * 60 + e;
}, cr = function(a) {
  var n = Math.floor(a / 3600), e = (a - n * 3600) / 60;
  return [n, e, a - n * 3600 - e * 60];
}, ur = {
  DAY: 864e5
};
function Ge(a) {
  var n = a.defaultHour, e = a.defaultMinute, r = a.defaultSeconds;
  if (a.minDate !== void 0) {
    var s = a.minDate.getHours(), l = a.minDate.getMinutes(), f = a.minDate.getSeconds();
    n < s && (n = s), n === s && e < l && (e = l), n === s && e === l && r < f && (r = a.minDate.getSeconds());
  }
  if (a.maxDate !== void 0) {
    var m = a.maxDate.getHours(), u = a.maxDate.getMinutes();
    n = Math.min(n, m), n === m && (e = Math.min(u, e)), n === m && e === u && (r = a.maxDate.getSeconds());
  }
  return { hours: n, minutes: e, seconds: r };
}
typeof Object.assign != "function" && (Object.assign = function(a) {
  for (var n = [], e = 1; e < arguments.length; e++)
    n[e - 1] = arguments[e];
  if (!a)
    throw TypeError("Cannot convert undefined or null to object");
  for (var r = function(m) {
    m && Object.keys(m).forEach(function(u) {
      return a[u] = m[u];
    });
  }, s = 0, l = n; s < l.length; s++) {
    var f = l[s];
    r(f);
  }
  return a;
});
var j = function() {
  return j = Object.assign || function(a) {
    for (var n, e = 1, r = arguments.length; e < r; e++) {
      n = arguments[e];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (a[s] = n[s]);
    }
    return a;
  }, j.apply(this, arguments);
}, yt = function() {
  for (var a = 0, n = 0, e = arguments.length; n < e; n++)
    a += arguments[n].length;
  for (var r = Array(a), s = 0, n = 0; n < e; n++)
    for (var l = arguments[n], f = 0, m = l.length; f < m; f++, s++)
      r[s] = l[f];
  return r;
}, dr = 300;
function fr(a, n) {
  var e = {
    config: j(j({}, me), N.defaultConfig),
    l10n: Ce
  };
  e.parseDate = Qe({ config: e.config, l10n: e.l10n }), e._handlers = [], e.pluginElements = [], e.loadedPlugins = [], e._bind = S, e._setHoursFromDate = P, e._positionCalendar = xe, e.changeMonth = We, e.changeYear = Se, e.clear = Pt, e.close = Lt, e.onMouseOver = Ee, e._createElement = _, e.createDay = ne, e.destroy = Ft, e.isEnabled = ce, e.jumpToDate = I, e.updateValue = ie, e.open = Wt, e.redraw = ut, e.set = zt, e.setDate = jt, e.toggle = Kt;
  function r() {
    e.utils = {
      getDaysInMonth: function(t, i) {
        return t === void 0 && (t = e.currentMonth), i === void 0 && (i = e.currentYear), t === 1 && (i % 4 === 0 && i % 100 !== 0 || i % 400 === 0) ? 29 : e.l10n.daysInMonth[t];
      }
    };
  }
  function s() {
    e.element = e.input = a, e.isOpen = !1, Rt(), ct(), qt(), Vt(), r(), e.isMobile || se(), w(), (e.selectedDates.length || e.config.noCalendar) && (e.config.enableTime && P(e.config.noCalendar ? e.latestSelectedDateObj : void 0), ie(!1)), m();
    var t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !e.isMobile && t && xe(), A("onReady");
  }
  function l() {
    var t;
    return ((t = e.calendarContainer) === null || t === void 0 ? void 0 : t.getRootNode()).activeElement || document.activeElement;
  }
  function f(t) {
    return t.bind(e);
  }
  function m() {
    var t = e.config;
    t.weekNumbers === !1 && t.showMonths === 1 || t.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (e.calendarContainer !== void 0 && (e.calendarContainer.style.visibility = "hidden", e.calendarContainer.style.display = "block"), e.daysContainer !== void 0) {
        var i = (e.days.offsetWidth + 1) * t.showMonths;
        e.daysContainer.style.width = i + "px", e.calendarContainer.style.width = i + (e.weekWrapper !== void 0 ? e.weekWrapper.offsetWidth : 0) + "px", e.calendarContainer.style.removeProperty("visibility"), e.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function u(t) {
    if (e.selectedDates.length === 0) {
      var i = e.config.minDate === void 0 || Z(/* @__PURE__ */ new Date(), e.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(e.config.minDate.getTime()), o = Ge(e.config);
      i.setHours(o.hours, o.minutes, o.seconds, i.getMilliseconds()), e.selectedDates = [i], e.latestSelectedDateObj = i;
    }
    t !== void 0 && t.type !== "blur" && Zt(t);
    var c = e._input.value;
    C(), ie(), e._input.value !== c && e._debouncedChange();
  }
  function v(t, i) {
    return t % 12 + 12 * Q(i === e.l10n.amPM[1]);
  }
  function y(t) {
    switch (t % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return t % 12;
    }
  }
  function C() {
    if (!(e.hourElement === void 0 || e.minuteElement === void 0)) {
      var t = (parseInt(e.hourElement.value.slice(-2), 10) || 0) % 24, i = (parseInt(e.minuteElement.value, 10) || 0) % 60, o = e.secondElement !== void 0 ? (parseInt(e.secondElement.value, 10) || 0) % 60 : 0;
      e.amPM !== void 0 && (t = v(t, e.amPM.textContent));
      var c = e.config.minTime !== void 0 || e.config.minDate && e.minDateHasTime && e.latestSelectedDateObj && Z(e.latestSelectedDateObj, e.config.minDate, !0) === 0, d = e.config.maxTime !== void 0 || e.config.maxDate && e.maxDateHasTime && e.latestSelectedDateObj && Z(e.latestSelectedDateObj, e.config.maxDate, !0) === 0;
      if (e.config.maxTime !== void 0 && e.config.minTime !== void 0 && e.config.minTime > e.config.maxTime) {
        var p = Je(e.config.minTime.getHours(), e.config.minTime.getMinutes(), e.config.minTime.getSeconds()), M = Je(e.config.maxTime.getHours(), e.config.maxTime.getMinutes(), e.config.maxTime.getSeconds()), h = Je(t, i, o);
        if (h > M && h < p) {
          var T = cr(p);
          t = T[0], i = T[1], o = T[2];
        }
      } else {
        if (d) {
          var g = e.config.maxTime !== void 0 ? e.config.maxTime : e.config.maxDate;
          t = Math.min(t, g.getHours()), t === g.getHours() && (i = Math.min(i, g.getMinutes())), i === g.getMinutes() && (o = Math.min(o, g.getSeconds()));
        }
        if (c) {
          var b = e.config.minTime !== void 0 ? e.config.minTime : e.config.minDate;
          t = Math.max(t, b.getHours()), t === b.getHours() && i < b.getMinutes() && (i = b.getMinutes()), i === b.getMinutes() && (o = Math.max(o, b.getSeconds()));
        }
      }
      V(t, i, o);
    }
  }
  function P(t) {
    var i = t || e.latestSelectedDateObj;
    i && i instanceof Date && V(i.getHours(), i.getMinutes(), i.getSeconds());
  }
  function V(t, i, o) {
    e.latestSelectedDateObj !== void 0 && e.latestSelectedDateObj.setHours(t % 24, i, o || 0, 0), !(!e.hourElement || !e.minuteElement || e.isMobile) && (e.hourElement.value = K(e.config.time_24hr ? t : (12 + t) % 12 + 12 * Q(t % 12 === 0)), e.minuteElement.value = K(i), e.amPM !== void 0 && (e.amPM.textContent = e.l10n.amPM[Q(t >= 12)]), e.secondElement !== void 0 && (e.secondElement.value = K(o)));
  }
  function te(t) {
    var i = G(t), o = parseInt(i.value) + (t.delta || 0);
    (o / 1e3 > 1 || t.key === "Enter" && !/[^\d]/.test(o.toString())) && Se(o);
  }
  function S(t, i, o, c) {
    if (i instanceof Array)
      return i.forEach(function(d) {
        return S(t, d, o, c);
      });
    if (t instanceof Array)
      return t.forEach(function(d) {
        return S(d, i, o, c);
      });
    t.addEventListener(i, o, c), e._handlers.push({
      remove: function() {
        return t.removeEventListener(i, o, c);
      }
    });
  }
  function k() {
    A("onChange");
  }
  function w() {
    if (e.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(o) {
      Array.prototype.forEach.call(e.element.querySelectorAll("[data-" + o + "]"), function(c) {
        return S(c, "click", e[o]);
      });
    }), e.isMobile) {
      Ut();
      return;
    }
    var t = vt(Nt, 50);
    if (e._debouncedChange = vt(k, dr), e.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && S(e.daysContainer, "mouseover", function(o) {
      e.config.mode === "range" && Ee(G(o));
    }), S(e._input, "keydown", rt), e.calendarContainer !== void 0 && S(e.calendarContainer, "keydown", rt), !e.config.inline && !e.config.static && S(window, "resize", t), window.ontouchstart !== void 0 ? S(window.document, "touchstart", Re) : S(window.document, "mousedown", Re), S(window.document, "focus", Re, { capture: !0 }), e.config.clickOpens === !0 && (S(e._input, "focus", e.open), S(e._input, "click", e.open)), e.daysContainer !== void 0 && (S(e.monthNav, "click", Gt), S(e.monthNav, ["keyup", "increment"], te), S(e.daysContainer, "click", dt)), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0) {
      var i = function(o) {
        return G(o).select();
      };
      S(e.timeContainer, ["increment"], u), S(e.timeContainer, "blur", u, { capture: !0 }), S(e.timeContainer, "click", Y), S([e.hourElement, e.minuteElement], ["focus", "click"], i), e.secondElement !== void 0 && S(e.secondElement, "focus", function() {
        return e.secondElement && e.secondElement.select();
      }), e.amPM !== void 0 && S(e.amPM, "click", function(o) {
        u(o);
      });
    }
    e.config.allowInput && S(e._input, "blur", Ot);
  }
  function I(t, i) {
    var o = t !== void 0 ? e.parseDate(t) : e.latestSelectedDateObj || (e.config.minDate && e.config.minDate > e.now ? e.config.minDate : e.config.maxDate && e.config.maxDate < e.now ? e.config.maxDate : e.now), c = e.currentYear, d = e.currentMonth;
    try {
      o !== void 0 && (e.currentYear = o.getFullYear(), e.currentMonth = o.getMonth());
    } catch (p) {
      p.message = "Invalid date supplied: " + o, e.config.errorHandler(p);
    }
    i && e.currentYear !== c && (A("onYearChange"), fe()), i && (e.currentYear !== c || e.currentMonth !== d) && A("onMonthChange"), e.redraw();
  }
  function Y(t) {
    var i = G(t);
    ~i.className.indexOf("arrow") && L(t, i.classList.contains("arrowUp") ? 1 : -1);
  }
  function L(t, i, o) {
    var c = t && G(t), d = o || c && c.parentNode && c.parentNode.firstChild, p = $e("increment");
    p.delta = i, d && d.dispatchEvent(p);
  }
  function se() {
    var t = window.document.createDocumentFragment();
    if (e.calendarContainer = _("div", "flatpickr-calendar"), e.calendarContainer.tabIndex = -1, !e.config.noCalendar) {
      if (t.appendChild(Bt()), e.innerContainer = _("div", "flatpickr-innerContainer"), e.config.weekNumbers) {
        var i = Ht(), o = i.weekWrapper, c = i.weekNumbers;
        e.innerContainer.appendChild(o), e.weekNumbers = c, e.weekWrapper = o;
      }
      e.rContainer = _("div", "flatpickr-rContainer"), e.rContainer.appendChild(it()), e.daysContainer || (e.daysContainer = _("div", "flatpickr-days"), e.daysContainer.tabIndex = -1), Te(), e.rContainer.appendChild(e.daysContainer), e.innerContainer.appendChild(e.rContainer), t.appendChild(e.innerContainer);
    }
    e.config.enableTime && t.appendChild(At()), q(e.calendarContainer, "rangeMode", e.config.mode === "range"), q(e.calendarContainer, "animate", e.config.animate === !0), q(e.calendarContainer, "multiMonth", e.config.showMonths > 1), e.calendarContainer.appendChild(t);
    var d = e.config.appendTo !== void 0 && e.config.appendTo.nodeType !== void 0;
    if ((e.config.inline || e.config.static) && (e.calendarContainer.classList.add(e.config.inline ? "inline" : "static"), e.config.inline && (!d && e.element.parentNode ? e.element.parentNode.insertBefore(e.calendarContainer, e._input.nextSibling) : e.config.appendTo !== void 0 && e.config.appendTo.appendChild(e.calendarContainer)), e.config.static)) {
      var p = _("div", "flatpickr-wrapper");
      e.element.parentNode && e.element.parentNode.insertBefore(p, e.element), p.appendChild(e.element), e.altInput && p.appendChild(e.altInput), p.appendChild(e.calendarContainer);
    }
    !e.config.static && !e.config.inline && (e.config.appendTo !== void 0 ? e.config.appendTo : window.document.body).appendChild(e.calendarContainer);
  }
  function ne(t, i, o, c) {
    var d = ce(i, !0), p = _("span", t, i.getDate().toString());
    return p.dateObj = i, p.$i = c, p.setAttribute("aria-label", e.formatDate(i, e.config.ariaDateFormat)), t.indexOf("hidden") === -1 && Z(i, e.now) === 0 && (e.todayDateElem = p, p.classList.add("today"), p.setAttribute("aria-current", "date")), d ? (p.tabIndex = -1, ze(i) && (p.classList.add("selected"), e.selectedDateElem = p, e.config.mode === "range" && (q(p, "startRange", e.selectedDates[0] && Z(i, e.selectedDates[0], !0) === 0), q(p, "endRange", e.selectedDates[1] && Z(i, e.selectedDates[1], !0) === 0), t === "nextMonthDay" && p.classList.add("inRange")))) : p.classList.add("flatpickr-disabled"), e.config.mode === "range" && Jt(i) && !ze(i) && p.classList.add("inRange"), e.weekNumbers && e.config.showMonths === 1 && t !== "prevMonthDay" && c % 7 === 6 && e.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + e.config.getWeek(i) + "</span>"), A("onDayCreate", p), p;
  }
  function ae(t) {
    t.focus(), e.config.mode === "range" && Ee(t);
  }
  function de(t) {
    for (var i = t > 0 ? 0 : e.config.showMonths - 1, o = t > 0 ? e.config.showMonths : -1, c = i; c != o; c += t)
      for (var d = e.daysContainer.children[c], p = t > 0 ? 0 : d.children.length - 1, M = t > 0 ? d.children.length : -1, h = p; h != M; h += t) {
        var T = d.children[h];
        if (T.className.indexOf("hidden") === -1 && ce(T.dateObj))
          return T;
      }
  }
  function Ne(t, i) {
    for (var o = t.className.indexOf("Month") === -1 ? t.dateObj.getMonth() : e.currentMonth, c = i > 0 ? e.config.showMonths : -1, d = i > 0 ? 1 : -1, p = o - e.currentMonth; p != c; p += d)
      for (var M = e.daysContainer.children[p], h = o - e.currentMonth === p ? t.$i + i : i < 0 ? M.children.length - 1 : 0, T = M.children.length, g = h; g >= 0 && g < T && g != (i > 0 ? T : -1); g += d) {
        var b = M.children[g];
        if (b.className.indexOf("hidden") === -1 && ce(b.dateObj) && Math.abs(t.$i - g) >= Math.abs(i))
          return ae(b);
      }
    e.changeMonth(d), ye(de(d), 0);
  }
  function ye(t, i) {
    var o = l(), c = _e(o || document.body), d = t !== void 0 ? t : c ? o : e.selectedDateElem !== void 0 && _e(e.selectedDateElem) ? e.selectedDateElem : e.todayDateElem !== void 0 && _e(e.todayDateElem) ? e.todayDateElem : de(i > 0 ? 1 : -1);
    d === void 0 ? e._input.focus() : c ? Ne(d, i) : ae(d);
  }
  function xt(t, i) {
    for (var o = (new Date(t, i, 1).getDay() - e.l10n.firstDayOfWeek + 7) % 7, c = e.utils.getDaysInMonth((i - 1 + 12) % 12, t), d = e.utils.getDaysInMonth(i, t), p = window.document.createDocumentFragment(), M = e.config.showMonths > 1, h = M ? "prevMonthDay hidden" : "prevMonthDay", T = M ? "nextMonthDay hidden" : "nextMonthDay", g = c + 1 - o, b = 0; g <= c; g++, b++)
      p.appendChild(ne("flatpickr-day " + h, new Date(t, i - 1, g), g, b));
    for (g = 1; g <= d; g++, b++)
      p.appendChild(ne("flatpickr-day", new Date(t, i, g), g, b));
    for (var E = d + 1; E <= 42 - o && (e.config.showMonths === 1 || b % 7 !== 0); E++, b++)
      p.appendChild(ne("flatpickr-day " + T, new Date(t, i + 1, E % d), E, b));
    var X = _("div", "dayContainer");
    return X.appendChild(p), X;
  }
  function Te() {
    if (e.daysContainer !== void 0) {
      Ae(e.daysContainer), e.weekNumbers && Ae(e.weekNumbers);
      for (var t = document.createDocumentFragment(), i = 0; i < e.config.showMonths; i++) {
        var o = new Date(e.currentYear, e.currentMonth, 1);
        o.setMonth(e.currentMonth + i), t.appendChild(xt(o.getFullYear(), o.getMonth()));
      }
      e.daysContainer.appendChild(t), e.days = e.daysContainer.firstChild, e.config.mode === "range" && e.selectedDates.length === 1 && Ee();
    }
  }
  function fe() {
    if (!(e.config.showMonths > 1 || e.config.monthSelectorType !== "dropdown")) {
      var t = function(c) {
        return e.config.minDate !== void 0 && e.currentYear === e.config.minDate.getFullYear() && c < e.config.minDate.getMonth() ? !1 : !(e.config.maxDate !== void 0 && e.currentYear === e.config.maxDate.getFullYear() && c > e.config.maxDate.getMonth());
      };
      e.monthsDropdownContainer.tabIndex = -1, e.monthsDropdownContainer.innerHTML = "";
      for (var i = 0; i < 12; i++)
        if (t(i)) {
          var o = _("option", "flatpickr-monthDropdown-month");
          o.value = new Date(e.currentYear, i).getMonth().toString(), o.textContent = Le(i, e.config.shorthandCurrentMonth, e.l10n), o.tabIndex = -1, e.currentMonth === i && (o.selected = !0), e.monthsDropdownContainer.appendChild(o);
        }
    }
  }
  function It() {
    var t = _("div", "flatpickr-month"), i = window.document.createDocumentFragment(), o;
    e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? o = _("span", "cur-month") : (e.monthsDropdownContainer = _("select", "flatpickr-monthDropdown-months"), e.monthsDropdownContainer.setAttribute("aria-label", e.l10n.monthAriaLabel), S(e.monthsDropdownContainer, "change", function(M) {
      var h = G(M), T = parseInt(h.value, 10);
      e.changeMonth(T - e.currentMonth), A("onMonthChange");
    }), fe(), o = e.monthsDropdownContainer);
    var c = He("cur-year", { tabindex: "-1" }), d = c.getElementsByTagName("input")[0];
    d.setAttribute("aria-label", e.l10n.yearAriaLabel), e.config.minDate && d.setAttribute("min", e.config.minDate.getFullYear().toString()), e.config.maxDate && (d.setAttribute("max", e.config.maxDate.getFullYear().toString()), d.disabled = !!e.config.minDate && e.config.minDate.getFullYear() === e.config.maxDate.getFullYear());
    var p = _("div", "flatpickr-current-month");
    return p.appendChild(o), p.appendChild(c), i.appendChild(p), t.appendChild(i), {
      container: t,
      yearElement: d,
      monthElement: o
    };
  }
  function at() {
    Ae(e.monthNav), e.monthNav.appendChild(e.prevMonthNav), e.config.showMonths && (e.yearElements = [], e.monthElements = []);
    for (var t = e.config.showMonths; t--; ) {
      var i = It();
      e.yearElements.push(i.yearElement), e.monthElements.push(i.monthElement), e.monthNav.appendChild(i.container);
    }
    e.monthNav.appendChild(e.nextMonthNav);
  }
  function Bt() {
    return e.monthNav = _("div", "flatpickr-months"), e.yearElements = [], e.monthElements = [], e.prevMonthNav = _("span", "flatpickr-prev-month"), e.prevMonthNav.innerHTML = e.config.prevArrow, e.nextMonthNav = _("span", "flatpickr-next-month"), e.nextMonthNav.innerHTML = e.config.nextArrow, at(), Object.defineProperty(e, "_hidePrevMonthArrow", {
      get: function() {
        return e.__hidePrevMonthArrow;
      },
      set: function(t) {
        e.__hidePrevMonthArrow !== t && (q(e.prevMonthNav, "flatpickr-disabled", t), e.__hidePrevMonthArrow = t);
      }
    }), Object.defineProperty(e, "_hideNextMonthArrow", {
      get: function() {
        return e.__hideNextMonthArrow;
      },
      set: function(t) {
        e.__hideNextMonthArrow !== t && (q(e.nextMonthNav, "flatpickr-disabled", t), e.__hideNextMonthArrow = t);
      }
    }), e.currentYearElement = e.yearElements[0], Be(), e.monthNav;
  }
  function At() {
    e.calendarContainer.classList.add("hasTime"), e.config.noCalendar && e.calendarContainer.classList.add("noCalendar");
    var t = Ge(e.config);
    e.timeContainer = _("div", "flatpickr-time"), e.timeContainer.tabIndex = -1;
    var i = _("span", "flatpickr-time-separator", ":"), o = He("flatpickr-hour", {
      "aria-label": e.l10n.hourAriaLabel
    });
    e.hourElement = o.getElementsByTagName("input")[0];
    var c = He("flatpickr-minute", {
      "aria-label": e.l10n.minuteAriaLabel
    });
    if (e.minuteElement = c.getElementsByTagName("input")[0], e.hourElement.tabIndex = e.minuteElement.tabIndex = -1, e.hourElement.value = K(e.latestSelectedDateObj ? e.latestSelectedDateObj.getHours() : e.config.time_24hr ? t.hours : y(t.hours)), e.minuteElement.value = K(e.latestSelectedDateObj ? e.latestSelectedDateObj.getMinutes() : t.minutes), e.hourElement.setAttribute("step", e.config.hourIncrement.toString()), e.minuteElement.setAttribute("step", e.config.minuteIncrement.toString()), e.hourElement.setAttribute("min", e.config.time_24hr ? "0" : "1"), e.hourElement.setAttribute("max", e.config.time_24hr ? "23" : "12"), e.hourElement.setAttribute("maxlength", "2"), e.minuteElement.setAttribute("min", "0"), e.minuteElement.setAttribute("max", "59"), e.minuteElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(o), e.timeContainer.appendChild(i), e.timeContainer.appendChild(c), e.config.time_24hr && e.timeContainer.classList.add("time24hr"), e.config.enableSeconds) {
      e.timeContainer.classList.add("hasSeconds");
      var d = He("flatpickr-second");
      e.secondElement = d.getElementsByTagName("input")[0], e.secondElement.value = K(e.latestSelectedDateObj ? e.latestSelectedDateObj.getSeconds() : t.seconds), e.secondElement.setAttribute("step", e.minuteElement.getAttribute("step")), e.secondElement.setAttribute("min", "0"), e.secondElement.setAttribute("max", "59"), e.secondElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(_("span", "flatpickr-time-separator", ":")), e.timeContainer.appendChild(d);
    }
    return e.config.time_24hr || (e.amPM = _("span", "flatpickr-am-pm", e.l10n.amPM[Q((e.latestSelectedDateObj ? e.hourElement.value : e.config.defaultHour) > 11)]), e.amPM.title = e.l10n.toggleTitle, e.amPM.tabIndex = -1, e.timeContainer.appendChild(e.amPM)), e.timeContainer;
  }
  function it() {
    e.weekdayContainer ? Ae(e.weekdayContainer) : e.weekdayContainer = _("div", "flatpickr-weekdays");
    for (var t = e.config.showMonths; t--; ) {
      var i = _("div", "flatpickr-weekdaycontainer");
      e.weekdayContainer.appendChild(i);
    }
    return ot(), e.weekdayContainer;
  }
  function ot() {
    if (e.weekdayContainer) {
      var t = e.l10n.firstDayOfWeek, i = yt(e.l10n.weekdays.shorthand);
      t > 0 && t < i.length && (i = yt(i.splice(t, i.length), i.splice(0, t)));
      for (var o = e.config.showMonths; o--; )
        e.weekdayContainer.children[o].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + i.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function Ht() {
    e.calendarContainer.classList.add("hasWeeks");
    var t = _("div", "flatpickr-weekwrapper");
    t.appendChild(_("span", "flatpickr-weekday", e.l10n.weekAbbreviation));
    var i = _("div", "flatpickr-weeks");
    return t.appendChild(i), {
      weekWrapper: t,
      weekNumbers: i
    };
  }
  function We(t, i) {
    i === void 0 && (i = !0);
    var o = i ? t : t - e.currentMonth;
    o < 0 && e._hidePrevMonthArrow === !0 || o > 0 && e._hideNextMonthArrow === !0 || (e.currentMonth += o, (e.currentMonth < 0 || e.currentMonth > 11) && (e.currentYear += e.currentMonth > 11 ? 1 : -1, e.currentMonth = (e.currentMonth + 12) % 12, A("onYearChange"), fe()), Te(), A("onMonthChange"), Be());
  }
  function Pt(t, i) {
    if (t === void 0 && (t = !0), i === void 0 && (i = !0), e.input.value = "", e.altInput !== void 0 && (e.altInput.value = ""), e.mobileInput !== void 0 && (e.mobileInput.value = ""), e.selectedDates = [], e.latestSelectedDateObj = void 0, i === !0 && (e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth()), e.config.enableTime === !0) {
      var o = Ge(e.config), c = o.hours, d = o.minutes, p = o.seconds;
      V(c, d, p);
    }
    e.redraw(), t && A("onChange");
  }
  function Lt() {
    e.isOpen = !1, e.isMobile || (e.calendarContainer !== void 0 && e.calendarContainer.classList.remove("open"), e._input !== void 0 && e._input.classList.remove("active")), A("onClose");
  }
  function Ft() {
    e.config !== void 0 && A("onDestroy");
    for (var t = e._handlers.length; t--; )
      e._handlers[t].remove();
    if (e._handlers = [], e.mobileInput)
      e.mobileInput.parentNode && e.mobileInput.parentNode.removeChild(e.mobileInput), e.mobileInput = void 0;
    else if (e.calendarContainer && e.calendarContainer.parentNode)
      if (e.config.static && e.calendarContainer.parentNode) {
        var i = e.calendarContainer.parentNode;
        if (i.lastChild && i.removeChild(i.lastChild), i.parentNode) {
          for (; i.firstChild; )
            i.parentNode.insertBefore(i.firstChild, i);
          i.parentNode.removeChild(i);
        }
      } else
        e.calendarContainer.parentNode.removeChild(e.calendarContainer);
    e.altInput && (e.input.type = "text", e.altInput.parentNode && e.altInput.parentNode.removeChild(e.altInput), delete e.altInput), e.input && (e.input.type = e.input._type, e.input.classList.remove("flatpickr-input"), e.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(o) {
      try {
        delete e[o];
      } catch {
      }
    });
  }
  function be(t) {
    return e.calendarContainer.contains(t);
  }
  function Re(t) {
    if (e.isOpen && !e.config.inline) {
      var i = G(t), o = be(i), c = i === e.input || i === e.altInput || e.element.contains(i) || t.path && t.path.indexOf && (~t.path.indexOf(e.input) || ~t.path.indexOf(e.altInput)), d = !c && !o && !be(t.relatedTarget), p = !e.config.ignoredFocusElements.some(function(M) {
        return M.contains(i);
      });
      d && p && (e.config.allowInput && e.setDate(e._input.value, !1, e.config.altInput ? e.config.altFormat : e.config.dateFormat), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0 && e.input.value !== "" && e.input.value !== void 0 && u(), e.close(), e.config && e.config.mode === "range" && e.selectedDates.length === 1 && e.clear(!1));
    }
  }
  function Se(t) {
    if (!(!t || e.config.minDate && t < e.config.minDate.getFullYear() || e.config.maxDate && t > e.config.maxDate.getFullYear())) {
      var i = t, o = e.currentYear !== i;
      e.currentYear = i || e.currentYear, e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth = Math.min(e.config.maxDate.getMonth(), e.currentMonth) : e.config.minDate && e.currentYear === e.config.minDate.getFullYear() && (e.currentMonth = Math.max(e.config.minDate.getMonth(), e.currentMonth)), o && (e.redraw(), A("onYearChange"), fe());
    }
  }
  function ce(t, i) {
    var o;
    i === void 0 && (i = !0);
    var c = e.parseDate(t, void 0, i);
    if (e.config.minDate && c && Z(c, e.config.minDate, i !== void 0 ? i : !e.minDateHasTime) < 0 || e.config.maxDate && c && Z(c, e.config.maxDate, i !== void 0 ? i : !e.maxDateHasTime) > 0)
      return !1;
    if (!e.config.enable && e.config.disable.length === 0)
      return !0;
    if (c === void 0)
      return !1;
    for (var d = !!e.config.enable, p = (o = e.config.enable) !== null && o !== void 0 ? o : e.config.disable, M = 0, h = void 0; M < p.length; M++) {
      if (h = p[M], typeof h == "function" && h(c))
        return d;
      if (h instanceof Date && c !== void 0 && h.getTime() === c.getTime())
        return d;
      if (typeof h == "string") {
        var T = e.parseDate(h, void 0, !0);
        return T && T.getTime() === c.getTime() ? d : !d;
      } else if (typeof h == "object" && c !== void 0 && h.from && h.to && c.getTime() >= h.from.getTime() && c.getTime() <= h.to.getTime())
        return d;
    }
    return !d;
  }
  function _e(t) {
    return e.daysContainer !== void 0 ? t.className.indexOf("hidden") === -1 && t.className.indexOf("flatpickr-disabled") === -1 && e.daysContainer.contains(t) : !1;
  }
  function Ot(t) {
    var i = t.target === e._input, o = e._input.value.trimEnd() !== je();
    i && o && !(t.relatedTarget && be(t.relatedTarget)) && e.setDate(e._input.value, !0, t.target === e.altInput ? e.config.altFormat : e.config.dateFormat);
  }
  function rt(t) {
    var i = G(t), o = e.config.wrap ? a.contains(i) : i === e._input, c = e.config.allowInput, d = e.isOpen && (!c || !o), p = e.config.inline && o && !c;
    if (t.keyCode === 13 && o) {
      if (c)
        return e.setDate(e._input.value, !0, i === e.altInput ? e.config.altFormat : e.config.dateFormat), e.close(), i.blur();
      e.open();
    } else if (be(i) || d || p) {
      var M = !!e.timeContainer && e.timeContainer.contains(i);
      switch (t.keyCode) {
        case 13:
          M ? (t.preventDefault(), u(), Ye()) : dt(t);
          break;
        case 27:
          t.preventDefault(), Ye();
          break;
        case 8:
        case 46:
          o && !e.config.allowInput && (t.preventDefault(), e.clear());
          break;
        case 37:
        case 39:
          if (!M && !o) {
            t.preventDefault();
            var h = l();
            if (e.daysContainer !== void 0 && (c === !1 || h && _e(h))) {
              var T = t.keyCode === 39 ? 1 : -1;
              t.ctrlKey ? (t.stopPropagation(), We(T), ye(de(1), 0)) : ye(void 0, T);
            }
          } else
            e.hourElement && e.hourElement.focus();
          break;
        case 38:
        case 40:
          t.preventDefault();
          var g = t.keyCode === 40 ? 1 : -1;
          e.daysContainer && i.$i !== void 0 || i === e.input || i === e.altInput ? t.ctrlKey ? (t.stopPropagation(), Se(e.currentYear - g), ye(de(1), 0)) : M || ye(void 0, g * 7) : i === e.currentYearElement ? Se(e.currentYear - g) : e.config.enableTime && (!M && e.hourElement && e.hourElement.focus(), u(t), e._debouncedChange());
          break;
        case 9:
          if (M) {
            var b = [
              e.hourElement,
              e.minuteElement,
              e.secondElement,
              e.amPM
            ].concat(e.pluginElements).filter(function(J) {
              return J;
            }), E = b.indexOf(i);
            if (E !== -1) {
              var X = b[E + (t.shiftKey ? -1 : 1)];
              t.preventDefault(), (X || e._input).focus();
            }
          } else
            !e.config.noCalendar && e.daysContainer && e.daysContainer.contains(i) && t.shiftKey && (t.preventDefault(), e._input.focus());
          break;
      }
    }
    if (e.amPM !== void 0 && i === e.amPM)
      switch (t.key) {
        case e.l10n.amPM[0].charAt(0):
        case e.l10n.amPM[0].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[0], C(), ie();
          break;
        case e.l10n.amPM[1].charAt(0):
        case e.l10n.amPM[1].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[1], C(), ie();
          break;
      }
    (o || be(i)) && A("onKeyDown", t);
  }
  function Ee(t, i) {
    if (i === void 0 && (i = "flatpickr-day"), !(e.selectedDates.length !== 1 || t && (!t.classList.contains(i) || t.classList.contains("flatpickr-disabled")))) {
      for (var o = t ? t.dateObj.getTime() : e.days.firstElementChild.dateObj.getTime(), c = e.parseDate(e.selectedDates[0], void 0, !0).getTime(), d = Math.min(o, e.selectedDates[0].getTime()), p = Math.max(o, e.selectedDates[0].getTime()), M = !1, h = 0, T = 0, g = d; g < p; g += ur.DAY)
        ce(new Date(g), !0) || (M = M || g > d && g < p, g < c && (!h || g > h) ? h = g : g > c && (!T || g < T) && (T = g));
      var b = Array.from(e.rContainer.querySelectorAll("*:nth-child(-n+" + e.config.showMonths + ") > ." + i));
      b.forEach(function(E) {
        var X = E.dateObj, J = X.getTime(), we = h > 0 && J < h || T > 0 && J > T;
        if (we) {
          E.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(pe) {
            E.classList.remove(pe);
          });
          return;
        } else if (M && !we)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(pe) {
          E.classList.remove(pe);
        }), t !== void 0 && (t.classList.add(o <= e.selectedDates[0].getTime() ? "startRange" : "endRange"), c < o && J === c ? E.classList.add("startRange") : c > o && J === c && E.classList.add("endRange"), J >= h && (T === 0 || J <= T) && lr(J, c, o) && E.classList.add("inRange"));
      });
    }
  }
  function Nt() {
    e.isOpen && !e.config.static && !e.config.inline && xe();
  }
  function Wt(t, i) {
    if (i === void 0 && (i = e._positionElement), e.isMobile === !0) {
      if (t) {
        t.preventDefault();
        var o = G(t);
        o && o.blur();
      }
      e.mobileInput !== void 0 && (e.mobileInput.focus(), e.mobileInput.click()), A("onOpen");
      return;
    } else if (e._input.disabled || e.config.inline)
      return;
    var c = e.isOpen;
    e.isOpen = !0, c || (e.calendarContainer.classList.add("open"), e._input.classList.add("active"), A("onOpen"), xe(i)), e.config.enableTime === !0 && e.config.noCalendar === !0 && e.config.allowInput === !1 && (t === void 0 || !e.timeContainer.contains(t.relatedTarget)) && setTimeout(function() {
      return e.hourElement.select();
    }, 50);
  }
  function st(t) {
    return function(i) {
      var o = e.config["_" + t + "Date"] = e.parseDate(i, e.config.dateFormat), c = e.config["_" + (t === "min" ? "max" : "min") + "Date"];
      o !== void 0 && (e[t === "min" ? "minDateHasTime" : "maxDateHasTime"] = o.getHours() > 0 || o.getMinutes() > 0 || o.getSeconds() > 0), e.selectedDates && (e.selectedDates = e.selectedDates.filter(function(d) {
        return ce(d);
      }), !e.selectedDates.length && t === "min" && P(o), ie()), e.daysContainer && (ut(), o !== void 0 ? e.currentYearElement[t] = o.getFullYear().toString() : e.currentYearElement.removeAttribute(t), e.currentYearElement.disabled = !!c && o !== void 0 && c.getFullYear() === o.getFullYear());
    };
  }
  function Rt() {
    var t = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], i = j(j({}, JSON.parse(JSON.stringify(a.dataset || {}))), n), o = {};
    e.config.parseDate = i.parseDate, e.config.formatDate = i.formatDate, Object.defineProperty(e.config, "enable", {
      get: function() {
        return e.config._enable;
      },
      set: function(b) {
        e.config._enable = pt(b);
      }
    }), Object.defineProperty(e.config, "disable", {
      get: function() {
        return e.config._disable;
      },
      set: function(b) {
        e.config._disable = pt(b);
      }
    });
    var c = i.mode === "time";
    if (!i.dateFormat && (i.enableTime || c)) {
      var d = N.defaultConfig.dateFormat || me.dateFormat;
      o.dateFormat = i.noCalendar || c ? "H:i" + (i.enableSeconds ? ":S" : "") : d + " H:i" + (i.enableSeconds ? ":S" : "");
    }
    if (i.altInput && (i.enableTime || c) && !i.altFormat) {
      var p = N.defaultConfig.altFormat || me.altFormat;
      o.altFormat = i.noCalendar || c ? "h:i" + (i.enableSeconds ? ":S K" : " K") : p + (" h:i" + (i.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(e.config, "minDate", {
      get: function() {
        return e.config._minDate;
      },
      set: st("min")
    }), Object.defineProperty(e.config, "maxDate", {
      get: function() {
        return e.config._maxDate;
      },
      set: st("max")
    });
    var M = function(b) {
      return function(E) {
        e.config[b === "min" ? "_minTime" : "_maxTime"] = e.parseDate(E, "H:i:S");
      };
    };
    Object.defineProperty(e.config, "minTime", {
      get: function() {
        return e.config._minTime;
      },
      set: M("min")
    }), Object.defineProperty(e.config, "maxTime", {
      get: function() {
        return e.config._maxTime;
      },
      set: M("max")
    }), i.mode === "time" && (e.config.noCalendar = !0, e.config.enableTime = !0), Object.assign(e.config, o, i);
    for (var h = 0; h < t.length; h++)
      e.config[t[h]] = e.config[t[h]] === !0 || e.config[t[h]] === "true";
    qe.filter(function(b) {
      return e.config[b] !== void 0;
    }).forEach(function(b) {
      e.config[b] = Ue(e.config[b] || []).map(f);
    }), e.isMobile = !e.config.disableMobile && !e.config.inline && e.config.mode === "single" && !e.config.disable.length && !e.config.enable && !e.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var h = 0; h < e.config.plugins.length; h++) {
      var T = e.config.plugins[h](e) || {};
      for (var g in T)
        qe.indexOf(g) > -1 ? e.config[g] = Ue(T[g]).map(f).concat(e.config[g]) : typeof i[g] > "u" && (e.config[g] = T[g]);
    }
    i.altInputClass || (e.config.altInputClass = lt().className + " " + e.config.altInputClass), A("onParseConfig");
  }
  function lt() {
    return e.config.wrap ? a.querySelector("[data-input]") : a;
  }
  function ct() {
    typeof e.config.locale != "object" && typeof N.l10ns[e.config.locale] > "u" && e.config.errorHandler(new Error("flatpickr: invalid locale " + e.config.locale)), e.l10n = j(j({}, N.l10ns.default), typeof e.config.locale == "object" ? e.config.locale : e.config.locale !== "default" ? N.l10ns[e.config.locale] : void 0), ue.D = "(" + e.l10n.weekdays.shorthand.join("|") + ")", ue.l = "(" + e.l10n.weekdays.longhand.join("|") + ")", ue.M = "(" + e.l10n.months.shorthand.join("|") + ")", ue.F = "(" + e.l10n.months.longhand.join("|") + ")", ue.K = "(" + e.l10n.amPM[0] + "|" + e.l10n.amPM[1] + "|" + e.l10n.amPM[0].toLowerCase() + "|" + e.l10n.amPM[1].toLowerCase() + ")";
    var t = j(j({}, n), JSON.parse(JSON.stringify(a.dataset || {})));
    t.time_24hr === void 0 && N.defaultConfig.time_24hr === void 0 && (e.config.time_24hr = e.l10n.time_24hr), e.formatDate = _t(e), e.parseDate = Qe({ config: e.config, l10n: e.l10n });
  }
  function xe(t) {
    if (typeof e.config.position == "function")
      return void e.config.position(e, t);
    if (e.calendarContainer !== void 0) {
      A("onPreCalendarPosition");
      var i = t || e._positionElement, o = Array.prototype.reduce.call(e.calendarContainer.children, function(rn, sn) {
        return rn + sn.offsetHeight;
      }, 0), c = e.calendarContainer.offsetWidth, d = e.config.position.split(" "), p = d[0], M = d.length > 1 ? d[1] : null, h = i.getBoundingClientRect(), T = window.innerHeight - h.bottom, g = p === "above" || p !== "below" && T < o && h.top > o, b = window.pageYOffset + h.top + (g ? -o - 2 : i.offsetHeight + 2);
      if (q(e.calendarContainer, "arrowTop", !g), q(e.calendarContainer, "arrowBottom", g), !e.config.inline) {
        var E = window.pageXOffset + h.left, X = !1, J = !1;
        M === "center" ? (E -= (c - h.width) / 2, X = !0) : M === "right" && (E -= c - h.width, J = !0), q(e.calendarContainer, "arrowLeft", !X && !J), q(e.calendarContainer, "arrowCenter", X), q(e.calendarContainer, "arrowRight", J);
        var we = window.document.body.offsetWidth - (window.pageXOffset + h.right), pe = E + c > window.document.body.offsetWidth, Qt = we + c > window.document.body.offsetWidth;
        if (q(e.calendarContainer, "rightMost", pe), !e.config.static)
          if (e.calendarContainer.style.top = b + "px", !pe)
            e.calendarContainer.style.left = E + "px", e.calendarContainer.style.right = "auto";
          else if (!Qt)
            e.calendarContainer.style.left = "auto", e.calendarContainer.style.right = we + "px";
          else {
            var Ve = Yt();
            if (Ve === void 0)
              return;
            var Xt = window.document.body.offsetWidth, en = Math.max(0, Xt / 2 - c / 2), tn = ".flatpickr-calendar.centerMost:before", nn = ".flatpickr-calendar.centerMost:after", an = Ve.cssRules.length, on = "{left:" + h.left + "px;right:auto;}";
            q(e.calendarContainer, "rightMost", !1), q(e.calendarContainer, "centerMost", !0), Ve.insertRule(tn + "," + nn + on, an), e.calendarContainer.style.left = en + "px", e.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function Yt() {
    for (var t = null, i = 0; i < document.styleSheets.length; i++) {
      var o = document.styleSheets[i];
      if (o.cssRules) {
        try {
          o.cssRules;
        } catch {
          continue;
        }
        t = o;
        break;
      }
    }
    return t ?? $t();
  }
  function $t() {
    var t = document.createElement("style");
    return document.head.appendChild(t), t.sheet;
  }
  function ut() {
    e.config.noCalendar || e.isMobile || (fe(), Be(), Te());
  }
  function Ye() {
    e._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(e.close, 0) : e.close();
  }
  function dt(t) {
    t.preventDefault(), t.stopPropagation();
    var i = function(b) {
      return b.classList && b.classList.contains("flatpickr-day") && !b.classList.contains("flatpickr-disabled") && !b.classList.contains("notAllowed");
    }, o = St(G(t), i);
    if (o !== void 0) {
      var c = o, d = e.latestSelectedDateObj = new Date(c.dateObj.getTime()), p = (d.getMonth() < e.currentMonth || d.getMonth() > e.currentMonth + e.config.showMonths - 1) && e.config.mode !== "range";
      if (e.selectedDateElem = c, e.config.mode === "single")
        e.selectedDates = [d];
      else if (e.config.mode === "multiple") {
        var M = ze(d);
        M ? e.selectedDates.splice(parseInt(M), 1) : e.selectedDates.push(d);
      } else
        e.config.mode === "range" && (e.selectedDates.length === 2 && e.clear(!1, !1), e.latestSelectedDateObj = d, e.selectedDates.push(d), Z(d, e.selectedDates[0], !0) !== 0 && e.selectedDates.sort(function(b, E) {
          return b.getTime() - E.getTime();
        }));
      if (C(), p) {
        var h = e.currentYear !== d.getFullYear();
        e.currentYear = d.getFullYear(), e.currentMonth = d.getMonth(), h && (A("onYearChange"), fe()), A("onMonthChange");
      }
      if (Be(), Te(), ie(), !p && e.config.mode !== "range" && e.config.showMonths === 1 ? ae(c) : e.selectedDateElem !== void 0 && e.hourElement === void 0 && e.selectedDateElem && e.selectedDateElem.focus(), e.hourElement !== void 0 && e.hourElement !== void 0 && e.hourElement.focus(), e.config.closeOnSelect) {
        var T = e.config.mode === "single" && !e.config.enableTime, g = e.config.mode === "range" && e.selectedDates.length === 2 && !e.config.enableTime;
        (T || g) && Ye();
      }
      k();
    }
  }
  var Ie = {
    locale: [ct, ot],
    showMonths: [at, m, it],
    minDate: [I],
    maxDate: [I],
    positionElement: [mt],
    clickOpens: [
      function() {
        e.config.clickOpens === !0 ? (S(e._input, "focus", e.open), S(e._input, "click", e.open)) : (e._input.removeEventListener("focus", e.open), e._input.removeEventListener("click", e.open));
      }
    ]
  };
  function zt(t, i) {
    if (t !== null && typeof t == "object") {
      Object.assign(e.config, t);
      for (var o in t)
        Ie[o] !== void 0 && Ie[o].forEach(function(c) {
          return c();
        });
    } else
      e.config[t] = i, Ie[t] !== void 0 ? Ie[t].forEach(function(c) {
        return c();
      }) : qe.indexOf(t) > -1 && (e.config[t] = Ue(i));
    e.redraw(), ie(!0);
  }
  function ft(t, i) {
    var o = [];
    if (t instanceof Array)
      o = t.map(function(c) {
        return e.parseDate(c, i);
      });
    else if (t instanceof Date || typeof t == "number")
      o = [e.parseDate(t, i)];
    else if (typeof t == "string")
      switch (e.config.mode) {
        case "single":
        case "time":
          o = [e.parseDate(t, i)];
          break;
        case "multiple":
          o = t.split(e.config.conjunction).map(function(c) {
            return e.parseDate(c, i);
          });
          break;
        case "range":
          o = t.split(e.l10n.rangeSeparator).map(function(c) {
            return e.parseDate(c, i);
          });
          break;
      }
    else
      e.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(t)));
    e.selectedDates = e.config.allowInvalidPreload ? o : o.filter(function(c) {
      return c instanceof Date && ce(c, !1);
    }), e.config.mode === "range" && e.selectedDates.sort(function(c, d) {
      return c.getTime() - d.getTime();
    });
  }
  function jt(t, i, o) {
    if (i === void 0 && (i = !1), o === void 0 && (o = e.config.dateFormat), t !== 0 && !t || t instanceof Array && t.length === 0)
      return e.clear(i);
    ft(t, o), e.latestSelectedDateObj = e.selectedDates[e.selectedDates.length - 1], e.redraw(), I(void 0, i), P(), e.selectedDates.length === 0 && e.clear(!1), ie(i), i && A("onChange");
  }
  function pt(t) {
    return t.slice().map(function(i) {
      return typeof i == "string" || typeof i == "number" || i instanceof Date ? e.parseDate(i, void 0, !0) : i && typeof i == "object" && i.from && i.to ? {
        from: e.parseDate(i.from, void 0),
        to: e.parseDate(i.to, void 0)
      } : i;
    }).filter(function(i) {
      return i;
    });
  }
  function Vt() {
    e.selectedDates = [], e.now = e.parseDate(e.config.now) || /* @__PURE__ */ new Date();
    var t = e.config.defaultDate || ((e.input.nodeName === "INPUT" || e.input.nodeName === "TEXTAREA") && e.input.placeholder && e.input.value === e.input.placeholder ? null : e.input.value);
    t && ft(t, e.config.dateFormat), e._initialDate = e.selectedDates.length > 0 ? e.selectedDates[0] : e.config.minDate && e.config.minDate.getTime() > e.now.getTime() ? e.config.minDate : e.config.maxDate && e.config.maxDate.getTime() < e.now.getTime() ? e.config.maxDate : e.now, e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth(), e.selectedDates.length > 0 && (e.latestSelectedDateObj = e.selectedDates[0]), e.config.minTime !== void 0 && (e.config.minTime = e.parseDate(e.config.minTime, "H:i")), e.config.maxTime !== void 0 && (e.config.maxTime = e.parseDate(e.config.maxTime, "H:i")), e.minDateHasTime = !!e.config.minDate && (e.config.minDate.getHours() > 0 || e.config.minDate.getMinutes() > 0 || e.config.minDate.getSeconds() > 0), e.maxDateHasTime = !!e.config.maxDate && (e.config.maxDate.getHours() > 0 || e.config.maxDate.getMinutes() > 0 || e.config.maxDate.getSeconds() > 0);
  }
  function qt() {
    if (e.input = lt(), !e.input) {
      e.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    e.input._type = e.input.type, e.input.type = "text", e.input.classList.add("flatpickr-input"), e._input = e.input, e.config.altInput && (e.altInput = _(e.input.nodeName, e.config.altInputClass), e._input = e.altInput, e.altInput.placeholder = e.input.placeholder, e.altInput.disabled = e.input.disabled, e.altInput.required = e.input.required, e.altInput.tabIndex = e.input.tabIndex, e.altInput.type = "text", e.input.setAttribute("type", "hidden"), !e.config.static && e.input.parentNode && e.input.parentNode.insertBefore(e.altInput, e.input.nextSibling)), e.config.allowInput || e._input.setAttribute("readonly", "readonly"), mt();
  }
  function mt() {
    e._positionElement = e.config.positionElement || e._input;
  }
  function Ut() {
    var t = e.config.enableTime ? e.config.noCalendar ? "time" : "datetime-local" : "date";
    e.mobileInput = _("input", e.input.className + " flatpickr-mobile"), e.mobileInput.tabIndex = 1, e.mobileInput.type = t, e.mobileInput.disabled = e.input.disabled, e.mobileInput.required = e.input.required, e.mobileInput.placeholder = e.input.placeholder, e.mobileFormatStr = t === "datetime-local" ? "Y-m-d\\TH:i:S" : t === "date" ? "Y-m-d" : "H:i:S", e.selectedDates.length > 0 && (e.mobileInput.defaultValue = e.mobileInput.value = e.formatDate(e.selectedDates[0], e.mobileFormatStr)), e.config.minDate && (e.mobileInput.min = e.formatDate(e.config.minDate, "Y-m-d")), e.config.maxDate && (e.mobileInput.max = e.formatDate(e.config.maxDate, "Y-m-d")), e.input.getAttribute("step") && (e.mobileInput.step = String(e.input.getAttribute("step"))), e.input.type = "hidden", e.altInput !== void 0 && (e.altInput.type = "hidden");
    try {
      e.input.parentNode && e.input.parentNode.insertBefore(e.mobileInput, e.input.nextSibling);
    } catch {
    }
    S(e.mobileInput, "change", function(i) {
      e.setDate(G(i).value, !1, e.mobileFormatStr), A("onChange"), A("onClose");
    });
  }
  function Kt(t) {
    if (e.isOpen === !0)
      return e.close();
    e.open(t);
  }
  function A(t, i) {
    if (e.config !== void 0) {
      var o = e.config[t];
      if (o !== void 0 && o.length > 0)
        for (var c = 0; o[c] && c < o.length; c++)
          o[c](e.selectedDates, e.input.value, e, i);
      t === "onChange" && (e.input.dispatchEvent($e("change")), e.input.dispatchEvent($e("input")));
    }
  }
  function $e(t) {
    var i = document.createEvent("Event");
    return i.initEvent(t, !0, !0), i;
  }
  function ze(t) {
    for (var i = 0; i < e.selectedDates.length; i++) {
      var o = e.selectedDates[i];
      if (o instanceof Date && Z(o, t) === 0)
        return "" + i;
    }
    return !1;
  }
  function Jt(t) {
    return e.config.mode !== "range" || e.selectedDates.length < 2 ? !1 : Z(t, e.selectedDates[0]) >= 0 && Z(t, e.selectedDates[1]) <= 0;
  }
  function Be() {
    e.config.noCalendar || e.isMobile || !e.monthNav || (e.yearElements.forEach(function(t, i) {
      var o = new Date(e.currentYear, e.currentMonth, 1);
      o.setMonth(e.currentMonth + i), e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? e.monthElements[i].textContent = Le(o.getMonth(), e.config.shorthandCurrentMonth, e.l10n) + " " : e.monthsDropdownContainer.value = o.getMonth().toString(), t.value = o.getFullYear().toString();
    }), e._hidePrevMonthArrow = e.config.minDate !== void 0 && (e.currentYear === e.config.minDate.getFullYear() ? e.currentMonth <= e.config.minDate.getMonth() : e.currentYear < e.config.minDate.getFullYear()), e._hideNextMonthArrow = e.config.maxDate !== void 0 && (e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth + 1 > e.config.maxDate.getMonth() : e.currentYear > e.config.maxDate.getFullYear()));
  }
  function je(t) {
    var i = t || (e.config.altInput ? e.config.altFormat : e.config.dateFormat);
    return e.selectedDates.map(function(o) {
      return e.formatDate(o, i);
    }).filter(function(o, c, d) {
      return e.config.mode !== "range" || e.config.enableTime || d.indexOf(o) === c;
    }).join(e.config.mode !== "range" ? e.config.conjunction : e.l10n.rangeSeparator);
  }
  function ie(t) {
    t === void 0 && (t = !0), e.mobileInput !== void 0 && e.mobileFormatStr && (e.mobileInput.value = e.latestSelectedDateObj !== void 0 ? e.formatDate(e.latestSelectedDateObj, e.mobileFormatStr) : ""), e.input.value = je(e.config.dateFormat), e.altInput !== void 0 && (e.altInput.value = je(e.config.altFormat)), t !== !1 && A("onValueUpdate");
  }
  function Gt(t) {
    var i = G(t), o = e.prevMonthNav.contains(i), c = e.nextMonthNav.contains(i);
    o || c ? We(o ? -1 : 1) : e.yearElements.indexOf(i) >= 0 ? i.select() : i.classList.contains("arrowUp") ? e.changeYear(e.currentYear + 1) : i.classList.contains("arrowDown") && e.changeYear(e.currentYear - 1);
  }
  function Zt(t) {
    t.preventDefault();
    var i = t.type === "keydown", o = G(t), c = o;
    e.amPM !== void 0 && o === e.amPM && (e.amPM.textContent = e.l10n.amPM[Q(e.amPM.textContent === e.l10n.amPM[0])]);
    var d = parseFloat(c.getAttribute("min")), p = parseFloat(c.getAttribute("max")), M = parseFloat(c.getAttribute("step")), h = parseInt(c.value, 10), T = t.delta || (i ? t.which === 38 ? 1 : -1 : 0), g = h + M * T;
    if (typeof c.value < "u" && c.value.length === 2) {
      var b = c === e.hourElement, E = c === e.minuteElement;
      g < d ? (g = p + g + Q(!b) + (Q(b) && Q(!e.amPM)), E && L(void 0, -1, e.hourElement)) : g > p && (g = c === e.hourElement ? g - p - Q(!e.amPM) : d, E && L(void 0, 1, e.hourElement)), e.amPM && b && (M === 1 ? g + h === 23 : Math.abs(g - h) > M) && (e.amPM.textContent = e.l10n.amPM[Q(e.amPM.textContent === e.l10n.amPM[0])]), c.value = K(g);
    }
  }
  return s(), e;
}
function ge(a, n) {
  for (var e = Array.prototype.slice.call(a).filter(function(f) {
    return f instanceof HTMLElement;
  }), r = [], s = 0; s < e.length; s++) {
    var l = e[s];
    try {
      if (l.getAttribute("data-fp-omit") !== null)
        continue;
      l._flatpickr !== void 0 && (l._flatpickr.destroy(), l._flatpickr = void 0), l._flatpickr = fr(l, n || {}), r.push(l._flatpickr);
    } catch (f) {
      console.error(f);
    }
  }
  return r.length === 1 ? r[0] : r;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(a) {
  return ge(this, a);
}, HTMLElement.prototype.flatpickr = function(a) {
  return ge([this], a);
});
var N = function(a, n) {
  return typeof a == "string" ? ge(window.document.querySelectorAll(a), n) : a instanceof Node ? ge([a], n) : ge(a, n);
};
N.defaultConfig = {};
N.l10ns = {
  en: j({}, Ce),
  default: j({}, Ce)
};
N.localize = function(a) {
  N.l10ns.default = j(j({}, N.l10ns.default), a);
};
N.setDefaults = function(a) {
  N.defaultConfig = j(j({}, N.defaultConfig), a);
};
N.parseDate = Qe({});
N.formatDate = _t({});
N.compareDates = Z;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(a) {
  return ge(this, a);
});
Date.prototype.fp_incr = function(a) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof a == "string" ? parseInt(a, 10) : a));
};
typeof window < "u" && (window.flatpickr = N);
/*! maska v2.1.10 | (c) Alexander Shabunevich | Released under the MIT license */
var pr = Object.defineProperty, mr = (a, n, e) => n in a ? pr(a, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[n] = e, ke = (a, n, e) => (mr(a, typeof n != "symbol" ? n + "" : n, e), e);
const bt = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
};
class wt {
  constructor(n = {}) {
    ke(this, "opts", {}), ke(this, "memo", /* @__PURE__ */ new Map());
    const e = { ...n };
    if (e.tokens != null) {
      e.tokens = e.tokensReplace ? { ...e.tokens } : { ...bt, ...e.tokens };
      for (const r of Object.values(e.tokens))
        typeof r.pattern == "string" && (r.pattern = new RegExp(r.pattern));
    } else
      e.tokens = bt;
    Array.isArray(e.mask) && (e.mask.length > 1 ? e.mask = [...e.mask].sort((r, s) => r.length - s.length) : e.mask = e.mask[0] ?? ""), e.mask === "" && (e.mask = null), this.opts = e;
  }
  masked(n) {
    return this.process(n, this.findMask(n));
  }
  unmasked(n) {
    return this.process(n, this.findMask(n), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(n) {
    const e = this.findMask(n);
    if (this.opts.mask == null || e == null)
      return !1;
    const r = this.process(n, e).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : typeof this.opts.mask == "function" ? r >= e.length : this.opts.mask.filter((s) => r >= s.length).length === this.opts.mask.length;
  }
  findMask(n) {
    const e = this.opts.mask;
    if (e == null)
      return null;
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return e(n);
    const r = this.process(n, e.slice(-1).pop() ?? "", !1);
    return e.find((s) => this.process(n, s, !1).length >= r.length) ?? "";
  }
  escapeMask(n) {
    const e = [], r = [];
    return n.split("").forEach((s, l) => {
      s === "!" && n[l - 1] !== "!" ? r.push(l - r.length) : e.push(s);
    }), { mask: e.join(""), escaped: r };
  }
  process(n, e, r = !0) {
    var s;
    if (e == null)
      return n;
    const l = `value=${n},mask=${e},masked=${r ? 1 : 0}`;
    if (this.memo.has(l))
      return this.memo.get(l);
    const { mask: f, escaped: m } = this.escapeMask(e), u = [], v = this.opts.tokens != null ? this.opts.tokens : {}, y = this.isReversed() ? -1 : 1, C = this.isReversed() ? "unshift" : "push", P = this.isReversed() ? 0 : f.length - 1, V = this.isReversed() ? () => w > -1 && I > -1 : () => w < f.length && I < n.length, te = (Y) => !this.isReversed() && Y <= P || this.isReversed() && Y >= P;
    let S, k = -1, w = this.isReversed() ? f.length - 1 : 0, I = this.isReversed() ? n.length - 1 : 0;
    for (; V(); ) {
      const Y = f.charAt(w), L = v[Y], se = (L == null ? void 0 : L.transform) != null ? L.transform(n.charAt(I)) : n.charAt(I);
      if (!m.includes(w) && L != null) {
        if (se.match(L.pattern) != null)
          u[C](se), L.repeated ? (k === -1 ? k = w : w === P && w !== k && (w = k - y), P === k && (w -= y)) : L.multiple && (w -= y), w += y;
        else if (L.multiple) {
          const ne = ((s = u[I - y]) == null ? void 0 : s.match(L.pattern)) != null, ae = f.charAt(w + y);
          ne && ae !== "" && v[ae] == null ? (w += y, I -= y) : u[C]("");
        } else
          se === S ? S = void 0 : L.optional && (w += y, I -= y);
        I += y;
      } else
        r && !this.isEager() && u[C](Y), se === Y && !this.isEager() ? I += y : S = Y, this.isEager() || (w += y);
      if (this.isEager())
        for (; te(w) && (v[f.charAt(w)] == null || m.includes(w)); )
          r ? u[C](f.charAt(w)) : f.charAt(w) === n.charAt(I) && (I += y), w += y;
    }
    return this.memo.set(l, u.join("")), this.memo.get(l);
  }
}
const Et = (a) => JSON.parse(a.replaceAll("'", '"')), Dt = (a, n = {}) => {
  const e = { ...n };
  return a.dataset.maska != null && a.dataset.maska !== "" && (e.mask = gr(a.dataset.maska)), a.dataset.maskaEager != null && (e.eager = Ze(a.dataset.maskaEager)), a.dataset.maskaReversed != null && (e.reversed = Ze(a.dataset.maskaReversed)), a.dataset.maskaTokensReplace != null && (e.tokensReplace = Ze(a.dataset.maskaTokensReplace)), a.dataset.maskaTokens != null && (e.tokens = hr(a.dataset.maskaTokens)), e;
}, Ze = (a) => a !== "" ? !!JSON.parse(a) : !0, gr = (a) => a.startsWith("[") && a.endsWith("]") ? Et(a) : a, hr = (a) => {
  if (a.startsWith("{") && a.endsWith("}"))
    return Et(a);
  const n = {};
  return a.split("|").forEach((e) => {
    const r = e.split(":");
    n[r[0]] = {
      pattern: new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), n;
};
class vr {
  constructor(n, e = {}) {
    ke(this, "items", /* @__PURE__ */ new Map()), ke(this, "beforeinputEvent", (r) => {
      const s = r.target, l = this.items.get(s);
      l.isEager() && "inputType" in r && r.inputType.startsWith("delete") && l.unmasked(s.value).length <= 1 && this.setMaskedValue(s, "");
    }), ke(this, "inputEvent", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && r.detail != null && typeof r.detail == "object" && "masked" in r.detail)
        return;
      const s = r.target, l = this.items.get(s), f = s.value, m = s.selectionStart, u = s.selectionEnd;
      let v = f;
      if (l.isEager()) {
        const y = l.masked(f), C = l.unmasked(f);
        C === "" && "data" in r && r.data != null ? v = r.data : C !== l.unmasked(y) && (v = C);
      }
      if (this.setMaskedValue(s, v), "inputType" in r && (r.inputType.startsWith("delete") || m != null && m < f.length))
        try {
          s.setSelectionRange(m, u);
        } catch {
        }
    }), this.options = e, typeof n == "string" ? this.init(
      Array.from(document.querySelectorAll(n)),
      this.getMaskOpts(e)
    ) : this.init(
      "length" in n ? Array.from(n) : [n],
      this.getMaskOpts(e)
    );
  }
  destroy() {
    for (const n of this.items.keys())
      n.removeEventListener("input", this.inputEvent), n.removeEventListener("beforeinput", this.beforeinputEvent);
    this.items.clear();
  }
  needUpdateOptions(n, e) {
    const r = this.items.get(n), s = new wt(Dt(n, this.getMaskOpts(e)));
    return JSON.stringify(r.opts) !== JSON.stringify(s.opts);
  }
  needUpdateValue(n) {
    const e = n.dataset.maskaValue;
    return e == null && n.value !== "" || e != null && e !== n.value;
  }
  getMaskOpts(n) {
    const { onMaska: e, preProcess: r, postProcess: s, ...l } = n;
    return l;
  }
  init(n, e) {
    for (const r of n) {
      const s = new wt(Dt(r, e));
      this.items.set(r, s), r.value !== "" && this.setMaskedValue(r, r.value), r.addEventListener("input", this.inputEvent), r.addEventListener("beforeinput", this.beforeinputEvent);
    }
  }
  setMaskedValue(n, e) {
    const r = this.items.get(n);
    this.options.preProcess != null && (e = this.options.preProcess(e));
    const s = r.masked(e), l = r.unmasked(r.isEager() ? s : e), f = r.completed(e), m = { masked: s, unmasked: l, completed: f };
    e = s, this.options.postProcess != null && (e = this.options.postProcess(e)), n.value = e, n.dataset.maskaValue = e, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((u) => u(m)) : this.options.onMaska(m)), n.dispatchEvent(new CustomEvent("maska", { detail: m })), n.dispatchEvent(new CustomEvent("input", { detail: m }));
  }
}
const Xe = /* @__PURE__ */ new WeakMap(), yr = (a) => {
  setTimeout(() => {
    var n;
    ((n = Xe.get(a)) == null ? void 0 : n.needUpdateValue(a)) === !0 && a.dispatchEvent(new CustomEvent("input"));
  });
}, br = (a, n) => {
  const e = a instanceof HTMLInputElement ? a : a.querySelector("input"), r = { ...n.arg };
  if (e == null || (e == null ? void 0 : e.type) === "file")
    return;
  yr(e);
  const s = Xe.get(e);
  if (s != null) {
    if (!s.needUpdateOptions(e, r))
      return;
    s.destroy();
  }
  if (n.value != null) {
    const l = n.value, f = (m) => {
      l.masked = m.masked, l.unmasked = m.unmasked, l.completed = m.completed;
    };
    r.onMaska = r.onMaska == null ? f : Array.isArray(r.onMaska) ? [...r.onMaska, f] : [r.onMaska, f];
  }
  Xe.set(e, new vr(e, r));
}, gs = /* @__PURE__ */ O({
  __name: "SwDatePicker",
  props: {
    date: {},
    id: {},
    label: {},
    placeholder: { default: "yyyy-mm-dd" }
  },
  emits: ["update:date", "instantiateFlatpickr"],
  setup(a, { expose: n, emit: e }) {
    const r = e, s = a, l = oe(), f = oe(s.date), m = oe(!1), u = oe(), v = H(() => ({
      allowInput: !0,
      defaultDate: s.date,
      maxDate: "today",
      errorHandler: () => {
      },
      onChange: P
    })), y = (k) => {
      l.value && (l.value.close(), k.stopPropagation());
    }, C = (k) => {
      k.key === "Escape" && y(k);
    };
    pn(() => {
      var w;
      m.value = navigator.maxTouchPoints > 0;
      const k = N(`#${s.id}`, v.value);
      l.value = "length" in k ? k[0] : k, r("instantiateFlatpickr", l.value), (w = l.value.calendarContainer) == null || w.addEventListener("keydown", C);
    }), mn(() => {
      var k;
      l.value && ((k = l.value.calendarContainer) == null || k.removeEventListener("keydown", C), l.value.destroy());
    }), Pe(
      () => s.date,
      (k) => {
        var w;
        f.value = k, (w = l.value) == null || w.setDate(k);
      }
    ), Pe(f, (k) => {
      var w;
      !Number.isNaN(Date.parse(k)) && l.value && ((w = l.value) == null || w.setDate(k));
    });
    const P = (k, w) => {
      if (!Number.isNaN(Date.parse(w))) {
        if (u.value === w)
          return;
        r("update:date", w), u.value = w;
      }
    }, V = (k) => {
      const w = k.relatedTarget, I = w && l.value && l.value.calendarContainer.contains(w), Y = !Number.isNaN(Date.parse(f.value));
      if (!I && Y) {
        const L = new Date(f.value).toISOString().split("T")[0];
        if (u.value === L)
          return;
        r("update:date", L), u.value = L;
      }
    }, te = oe();
    return n({ focus: () => {
      var k;
      (k = te.value) == null || k.focus();
    } }), (k, w) => tt((D(), W(tr, {
      id: k.id,
      ref_key: "swTextInputElement",
      ref: te,
      modelValue: f.value,
      "onUpdate:modelValue": w[0] || (w[0] = (I) => f.value = I),
      label: k.label,
      "data-maska": "####-##-##",
      autocomplete: "off",
      placeholder: k.placeholder,
      onKeydown: Ct(y, ["esc"]),
      onBlur: V,
      icon: m.value ? void 0 : "calendar"
    }, null, 8, ["id", "modelValue", "label", "placeholder", "icon"])), [
      [he(br)]
    ]);
  }
}), wr = ["aria-description"], Dr = /* @__PURE__ */ O({
  __name: "SwTag",
  props: {
    color: {},
    label: {},
    size: { default: "regular" }
  },
  setup(a) {
    return (n, e) => (D(), x("div", {
      class: B(`tag ${n.color} ${n.size}`),
      "aria-description": n.label
    }, [
      n.size === "regular" ? (D(), x(gn, { key: 0 }, [
        et(U(n.label), 1)
      ], 64)) : R("", !0)
    ], 10, wr));
  }
}), hs = /* @__PURE__ */ z(Dr, [["__scopeId", "data-v-844af662"]]), kr = /* @__PURE__ */ O({
  __name: "SwTransitionExpand",
  setup(a) {
    const n = (s) => {
      const l = s.style.position, f = s.style.visibility, m = s.style.width, u = getComputedStyle(s).width;
      s.style.width = u, s.style.position = "absolute", s.style.visibility = "hidden", s.style.height = "auto";
      const v = getComputedStyle(s).height;
      s.style.position = l, s.style.visibility = f, s.style.width = m, s.style.height = "0", getComputedStyle(s).height, requestAnimationFrame(() => {
        s.style.height = v;
      });
    }, e = (s) => {
      s.style.height = "auto";
    }, r = (s) => {
      const l = getComputedStyle(s).height;
      s.style.height = l, getComputedStyle(s).height, requestAnimationFrame(() => {
        s.style.height = "0";
      });
    };
    return (s, l) => (D(), W(hn, {
      name: "expand",
      onEnter: l[0] || (l[0] = (f) => n(f)),
      onAfterEnter: l[1] || (l[1] = (f) => e(f)),
      onLeave: l[2] || (l[2] = (f) => r(f))
    }, {
      default: re(() => [
        le(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), vs = /* @__PURE__ */ z(kr, [["__scopeId", "data-v-be155422"]]), Mr = ["id", "value", "aria-label", "placeholder"], Cr = ["aria-label"], Tr = ["aria-label"], Sr = {
  inheritAttrs: !1
}, _r = /* @__PURE__ */ O({
  ...Sr,
  __name: "SwSearchInput",
  props: {
    id: {},
    modelValue: {},
    searchAriaLabel: {},
    clearAriaLabel: {},
    submitAriaLabel: {},
    fullWidth: { type: Boolean, default: !1 },
    placeholderText: { default: "Search..." }
  },
  emits: ["update:modelValue"],
  setup(a, { expose: n, emit: e }) {
    const r = a, s = e, l = oe(), f = () => {
      var C;
      (C = l.value) == null || C.focus();
    };
    n({ focus: f });
    const m = H({
      get: () => r.modelValue,
      set: (C) => s("update:modelValue", C)
    }), u = () => {
      m.value = "";
    }, v = (C) => {
      m.value && (C.stopPropagation(), u());
    }, y = H(() => ({
      "full-width": r.fullWidth
    }));
    return (C, P) => (D(), x("div", {
      class: B(["input-wrapper", y.value]),
      role: "search",
      onClick: f
    }, [
      Me(ee, {
        name: "search",
        color: he($).tertiaryForeground,
        class: "search-icon",
        "aria-hidden": "true"
      }, null, 8, ["color"]),
      F("input", ve({
        id: C.id,
        value: C.modelValue
      }, C.$attrs, {
        ref_key: "inputRef",
        ref: l,
        type: "text",
        role: "searchbox",
        "aria-label": C.searchAriaLabel,
        class: ["input", y.value],
        autocomplete: "off",
        placeholder: C.placeholderText,
        onKeydown: Ct(v, ["esc"]),
        onInput: P[0] || (P[0] = (V) => s("update:modelValue", V.target.value))
      }), null, 16, Mr),
      F("button", {
        class: "submit-button",
        type: "submit",
        "aria-label": C.submitAriaLabel,
        tabindex: "-1"
      }, null, 8, Cr),
      m.value.length ? (D(), x("button", {
        key: 0,
        class: "clear-button",
        "aria-label": C.clearAriaLabel,
        onClick: u
      }, [
        Me(ee, {
          name: "cross",
          color: he($).secondaryForeground,
          height: 20,
          width: 20,
          "aria-hidden": "true"
        }, null, 8, ["color"])
      ], 8, Tr)) : R("", !0)
    ], 2));
  }
}), ys = /* @__PURE__ */ z(_r, [["__scopeId", "data-v-a0b50f8b"]]), Er = { class: "dialog-inner" }, xr = { class: "title" }, Ir = { class: "content" }, Br = { class: "footer" }, Ar = /* @__PURE__ */ O({
  __name: "SwModal",
  props: {
    title: {},
    closeButtonAriaLabel: {},
    size: { default: "default" },
    hideCloseButton: { type: Boolean, default: !1 }
  },
  emits: ["onClose"],
  setup(a, { expose: n, emit: e }) {
    const r = e, s = oe(), l = () => {
      var u;
      (u = s.value) == null || u.showModal();
    }, f = () => {
      var u;
      r("onClose"), (u = s.value) == null || u.close();
    }, m = (u) => {
      u.target.nodeName === "DIALOG" && f();
    };
    return n({
      openModal: l,
      closeModal: f
    }), (u, v) => (D(), x("dialog", {
      ref_key: "dialog",
      ref: s,
      class: B(u.size),
      onClick: m
    }, [
      F("div", Er, [
        u.hideCloseButton ? R("", !0) : (D(), W(_o, {
          key: 0,
          "icon-name": "cross",
          variant: "secondary",
          "aria-label": u.closeButtonAriaLabel,
          class: "close-button",
          autofocus: "",
          onClick: f
        }, null, 8, ["aria-label"])),
        F("div", xr, [
          u.title ? (D(), W(nt, {
            key: 0,
            variant: "tertiary-title-bold",
            element: "h1"
          }, {
            default: re(() => [
              et(U(u.title), 1)
            ]),
            _: 1
          })) : R("", !0)
        ]),
        F("div", Ir, [
          le(u.$slots, "default", {}, void 0, !0)
        ]),
        F("div", Br, [
          le(u.$slots, "footer", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
}), bs = /* @__PURE__ */ z(Ar, [["__scopeId", "data-v-9cda7922"]]);
export {
  ls as SwButton,
  ds as SwCheckbox,
  gs as SwDatePicker,
  _o as SwIconButton,
  ss as SwLinkButton,
  bo as SwLoadingDots,
  bs as SwModal,
  us as SwRadioButton,
  ys as SwSearchInput,
  cs as SwSmallButton,
  rs as SwSvgGraphic,
  ee as SwSvgIcon,
  hs as SwTag,
  nt as SwText,
  ps as SwTextArea,
  tr as SwTextInput,
  ms as SwTextTooltip,
  fs as SwToggle,
  or as SwTooltip,
  vs as SwTransitionExpand,
  Nr as breakPoints,
  Rr as buttonHtmlElements,
  Gr as buttonIconNames,
  $r as buttonSizes,
  Yr as buttonVariants,
  Or as fontSizes,
  Fr as fontWeights,
  Lr as gradientColors,
  Xr as graphicNames,
  zr as iconButtonVariants,
  po as iconNames,
  Wr as lineHeights,
  jr as linkButtonHtmlElements,
  Qr as loadingDotsColors,
  Zr as loadingDotsSizes,
  $ as mainColors,
  os as modalSizes,
  Vr as smallButtonVariants,
  ts as tagSizes,
  es as tagStyleColors,
  is as textAreaResizeProperties,
  Jr as textElements,
  Ur as textStyleAlignment,
  Kr as textStyleColors,
  qr as textStyleVariants,
  Pr as tintColors,
  ns as tooltipAlign,
  as as tooltipDirection
};
